import React, { Component, Suspense } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {
  Button,
  Card,
  Collapse,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Row,
  Nav,
  NavItem,
  NavLink,
  Input,
  InputGroup,
  InputGroupAddon,
  Container,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
  Label, CustomInput, Modal as SystemModal
} from 'reactstrap';
import { Helmet } from 'react-helmet';
import Modal from 'react-responsive-modal';
import { Carousel } from 'react-responsive-carousel';
import ModalVideo from 'react-modal-video';
import Page404 from '../Pages/Page404/Page404';
import '../../scss/minbodyheight.scss';
import '../../scss/backendimage.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Loader from 'react-loader-spinner';
import PRODUCTDESKIMAGE from '../../assets/img/agilitydeskbackground.png';
import PRODUCTMOBIMAGE from '../../assets/img/agilitymobbackground.png';
import SMALLWHITE from '../../assets/img/smallwhite.png';
import SMALLWHITE_WEBP from '../../assets/img/smallwhite.webp';
import SMALLBLACK from '../../assets/img/smallblack.png';
import SMALLBLACK_WEBP from '../../assets/img/smallblack.webp';
import YELLOWRIGHT from '../../assets/img/yellow_right_arrow.png';
import YELLOWRIGHT_WEBP from '../../assets/img/yellow_right_arrow.webp';
import REDARROW from '../../assets/img/red_arrow.png';
import REDARROW_WEBP from '../../assets/img/red_arrow.webp';
import REGISTER from '../../assets/img/register.png';
import REGISTER_WEBP from '../../assets/img/register.webp';
import JOINCOMMUNITY from '../../assets/img/join_our_community_video.png';
import JOINCOMMUNITY_WEBP from '../../assets/img/join_our_community_video.webp';import GPLAY from '../../assets/img/gplay.png';
import GPLAY_WEBP from '../../assets/img/gplay.webp';
import GPLAYSTORE from '../../assets/img/gplay_store.png';
import GPLAYSTORE_WEBP from '../../assets/img/gplay_store.webp';
import APPLE from '../../assets/img/appstore.png';
import APPLE_WEBP from '../../assets/img/appstore.webp';
import APPLESTORE from '../../assets/img/apple_store.png';
import APPLESTORE_WEBP from '../../assets/img/apple_store.webp';
import hideMessage from '../../HideMessage';
import './AgilityThinking.scss';

class AllVideos extends React.Component {
  constructor(props) {
    super(props);
    this.state= {
      isVideoOpen: false,
      width: window.innerWidth,
    }
    this.openVideoModal = this.openVideoModal.bind(this)
  }

  componentWillUnmount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  openVideoModal(){
    this.setState({isVideoOpen: true})
  }

  componentDidMount() {
    if (this.props.channel == 'vimeo')
      this.showThumbnail(this.props.url, this.props.video_id, this.props.video_name)
  }

  showThumbnail(url, id, name) {
    axios.get('https://vimeo.com/api/oembed.json?url='+url).then(response =>
    response.data).then(data => {
      var id_img = "vimeo-"+name+"-"+id;
      if (document.getElementById(id_img)){
      document.getElementById(id_img).style.backgroundImage =
        'url( ' + data.thumbnail_url +  ')';
      }
    });
  }
  dateFormat(value){
    let monthNames = [
      "Jan", "Feb", "Mar",
      "Apr", "May", "Jun", "Jul",
      "Aug", "Sep", "Oct",
      "Nov", "Dec"
    ];
    let date_suffix = [
      'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th',
      'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'st', 'nd', 'rd', 'th',
      'th', 'th', 'th', 'th', 'th', 'th', 'st'
    ]
    let start_date = new Date(value);
    // let node = document.createElement("sup");
    // let display_suffix = document.createTextNode(date_suffix[(start_date.getDate() - 1).toString()]);
    // let suffix = node.appendChild(display_suffix).toString()
    let display_suffix = date_suffix[(start_date.getDate() - 1).toString()];
    let date = start_date.getDate().toString()+display_suffix+' '+monthNames[start_date.getMonth().toString()]+', '+start_date.getFullYear().toString()
    return date;
  }

  render(){
   const { width } = this.state;
   const isMobile = width <= 980;
   if (isMobile) {
     if (this.props.channel === 'vimeo') {
       return (
         <Col xs="9" sm="9" md="9" className="text-center float-left" style={{maxWidth: '300px'}}>
           <Col xs="12" sm="12" lg="12" className="float-left px-0">
             <div className="overlay" style={{background: this.props.is_webinar === true ? 'rgba(0, 0, 0, 0.65)' : 'rgba(0, 0, 0, 0.25)', borderRadius: 0}} onClick={this.openVideoModal}></div>
             <Col xs="12" sm="12" lg="12" className={`video-background-image video-back pl-0 pr-0 embed-responsive-item` } id={`vimeo-${this.props.video_name}-${this.props.video_id}`} style={{backgroundImage: `url('')`, borderRadius: '0'}}>
               <ModalVideo channel={this.props.channel} isOpen={this.state.isVideoOpen} videoId={this.props.video_id} onClose={() => this.setState({isVideoOpen: false})} autoPlay={1}/>
                 <Col sm="12" md="12" xs="12" className={`overlay-div float-left text-left text-white ${this.props.is_webinar === true ? '' : 'hidden'}`} style={{position: 'absolute', bottom: '0'}}>
                   <Col sm="12" md="12" xs="12" className="float-left px-0 mb-1" style={{maxHeight: '45px', overflow: 'auto'}}>
                     <h6 className="mb-0" style={{color: 'rgb(255, 255, 0)'}}> {this.props.title} </h6>
                   </Col>
                   <h6 style={{fontWeight: '400'}}>{this.dateFormat(this.props.date)}</h6>
                 </Col>
               <i className={`fa fa-play font-3 pointer text-white overlay-div center text-center ${this.props.is_webinar === true ? 'hidden' : ''}`} aria-hidden="true" onClick={this.openVideoModal} style={{position: 'absolute', left: '42%', top: '40%'}}></i>
             </Col>
           </Col>
         </Col>
       )
     } else {
       return (
         <Col xs="9" sm="9" md="9" className="text-center float-left" style={{maxWidth: '300px'}}>
          <Col xs="12" sm="12" lg="12" className="float-left px-0">
            <div className="overlay" style={{background: this.props.is_webinar === true ? 'rgba(0, 0, 0, 0.65)' : 'rgba(0, 0, 0, 0.25)', borderRadius: 0}} onClick={this.openVideoModal}></div>
            <Col xs="12" sm="12" lg="12" className={`video-background-image video-back pl-0 pr-0` } style={{backgroundImage: `url(https://img.youtube.com/vi/${this.props.video_id}/mqdefault.jpg)`, borderRadius: '0'}}>
              <ModalVideo channel={this.props.channel} isOpen={this.state.isVideoOpen} videoId={this.props.video_id} onClose={() => this.setState({isVideoOpen: false})} autoPlay={1}/>
                <Col sm="12" md="12" xs="12" className={`overlay-div float-left text-left text-white ${this.props.is_webinar === true ? '' : 'hidden'}`} style={{position: 'absolute', bottom: '0'}}>
                  <Col sm="12" md="12" xs="12" className="float-left px-0 mb-1" style={{maxHeight: '45px', overflow: 'auto'}}>
                    <h6 className="mb-0" style={{color: 'rgb(255, 255, 0)'}}> {this.props.title} </h6>
                  </Col>
                  <h6 style={{fontWeight: '400'}}>{this.dateFormat(this.props.date)}</h6>
                </Col>
              <i className={`fa fa-play font-3 pointer text-white overlay-div center text-center ${this.props.is_webinar === true ? 'hidden' : ''}`}  aria-hidden="true" onClick={this.openVideoModal} style={{position: 'absolute', left: '42%', top: '40%'}}></i>
            </Col>
          </Col>
         </Col>
       )
     }
   } else {
     if (this.props.channel === 'vimeo') {
       return (
         <Col sm="6" md="4" lg={`${this.props.type === '' ? '3' : '4'}`} className={`text-center float-left ${this.props.type === '' ? '' : 'm-t-2'}`}>
           <Col sm="12" md="12" lg="12" className="px-0 float-left">
             <div className="pointer overlay" onClick={this.openVideoModal} style={{background: this.props.is_webinar === true ? 'rgba(0, 0, 0, 0.65)' : 'rgba(0, 0, 0, 0.25)', borderRadius: 0}}></div>
             <Col xs="12" sm="12" lg="12" className={`video_desk_div video_desk_div_bg pointer desk_video_text_display` } id={`vimeo-${this.props.video_name}-${this.props.video_id}`} style={{backgroundImage: `url('')`}}>
               <Col sm="12" md="12" xs="12" className={`overlay-div float-left text-left text-white ${this.props.is_webinar === true ? '' : 'hidden'}`}>
                 <Col sm="12" md="12" xs="12" className="float-left px-0 mb-1" style={{maxHeight: '45px', overflow: 'auto'}}>
                   <h6 className="mb-0" style={{color: 'rgb(255, 255, 0)'}}> {this.props.title} </h6>
                 </Col>
                 <h6 style={{fontWeight: '400'}}>{this.dateFormat(this.props.date)}</h6>
               </Col>
             </Col>
           </Col>
           <ModalVideo channel={this.props.channel} isOpen={this.state.isVideoOpen} videoId={this.props.video_id} autoPlay={1} onClose={() => this.setState({isVideoOpen: false})}/>
         </Col>
       )
     } else {
       return (
         <Col sm="6" md="4" lg={`${this.props.type === '' ? '3' : '4'}`} className={`text-center float-left ${this.props.type === '' ? '' : 'm-t-2'}`}>
           <Col sm="12" md="12" lg="12" className="px-0 float-left">
             <div className="pointer overlay" onClick={this.openVideoModal} style={{background: this.props.is_webinar === true ? 'rgba(0, 0, 0, 0.65)' : 'rgba(0, 0, 0, 0.25)', borderRadius: 0}}></div>
             <Col xs="12" sm="12" lg="12" className={`video_desk_div video_desk_div_bg pointer desk_video_text_display` } style={{backgroundImage: `url(https://img.youtube.com/vi/${this.props.video_id}/mqdefault.jpg)`}}>
               <Col sm="12" md="12" xs="12" className={`overlay-div float-left text-left text-white ${this.props.is_webinar === true ? '' : 'hidden'}`}>
                 <Col sm="12" md="12" xs="12" className="float-left px-0 mb-1" style={{maxHeight: '45px', overflow: 'auto'}}>
                   <h6 className="mb-0" style={{color: 'rgb(255, 255, 0)'}}> {this.props.title} </h6>
                 </Col>
                 <h6 style={{fontWeight: '400'}}>{this.dateFormat(this.props.date)}</h6>
               </Col>
             </Col>
           </Col>
           <ModalVideo channel={this.props.channel} isOpen={this.state.isVideoOpen} videoId={this.props.video_id} autoPlay={1} onClose={() => this.setState({isVideoOpen: false})}/>
         </Col>
       )
     }
   }
 }
}

class SmSeries extends React.Component {
  constructor(props) {
    super(props);
    this.state= {
      isVideoOpen: false,
      width: window.innerWidth,
    }
  }
  componentWillUnmount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };
  openUrl(url) {
    window.open(`/videos/${url}`)
  }
  converToUrl(url){
    url = url.split(' ').join('-')
    this.openUrl(url)
  }

  render(){
   const { width } = this.state;
   const isMobile = width <= 980;
   let avatar = '';
   if (this.props.avatar === '') {
     avatar = 'https://i.vimeocdn.com/video/801225227_295x166.jpg'
   } else {
     avatar = this.props.avatar
   }
   if (isMobile) {
     return (
       <Col xs="9" sm="9" md="9" className="text-center float-left" style={{maxWidth: '300px'}}>
        <Col xs="12" sm="12" lg="12" className="float-left px-0" onClick={() => {this.converToUrl(this.props.name)}}>
          <div className="overlay" style={{borderRadius: '0', background: 'rgba(0, 0, 0, 0.25)'}}></div>
          <Col xs="12" sm="12" lg="12" className={`video-background-image video-back px-0` } style={{backgroundImage: `url(${avatar})`, borderRadius: '0'}}>
          </Col>
        </Col>
       </Col>
     )
   } else {
     return (
       <Col sm="6" md="4" lg={`${this.props.type === '' ? '3' : '4'}`} className={`text-center float-left ${this.props.type === '' ? '' : 'm-t-2'}`}>
         <Col sm="12" md="12" lg="12" className="px-0 float-left" onClick={() => {this.converToUrl(this.props.name)}}>
           <div className="overlay pointer" style={{borderRadius: '0', background: 'rgba(0, 0, 0, 0.25)'}}></div>
           <Col xs="12" sm="12" lg="12" className={`video_desk_div video_desk_div_bg pointer desk_video_text_display` } style={{backgroundImage: `url(${avatar})`}}>
           </Col>
         </Col>
       </Col>
     )
   }
 }
}

class SoundCloudPlayer extends React.Component {
  constructor(props) {
    super(props);

    this.state= {
      width: window.innerWidth,
    }
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render(){
    const { width } = this.state;
    const isMobile = width <= 980;

    if (isMobile) {
      return (
        <Col sm="9" md="9" xs="9" className="text-center float-left" style={{maxWidth: '300px'}}>
          <Col sm="12" md="12" xs="12" className="px-0 float-left">
            <iframe scrolling="no" frameBorder="no" allow="autoplay" src= {`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${this.props.audio_id}%3Fsecret_token%3D${this.props.secret_token}&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true`} style={{borderRadius: '5px', border: '1px solid rgb(0, 0, 0)'}}></iframe>
          </Col>
        </Col>
      );
    } else {
      return (
        <Col sm="6" md="4" lg={`${this.props.type === '' ? '3' : '4'}`} className={`text-center float-left ${this.props.type === '' ? '' : 'm-t-2'}`}>
          <Col sm="12" md="12" lg="12" className="px-0 float-left">
            <iframe scrolling="no" frameBorder="no" allow="autoplay" src= {`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${this.props.audio_id}%3Fsecret_token%3D${this.props.secret_token}&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true`} style={{borderRadius: '5px', border: '1px solid rgb(0, 0, 0)'}}></iframe>
          </Col>
        </Col>
      );
    }
  }
}

class Blogs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    }
  }
  componentWillUnmount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };
  openUrl(platform, url){
    if (platform === true) {
      window.open(`https://medium.com/product-musings/${url}`)
    } else {
      window.open(`/blogs/${url}`)
    }
  }

  render() {
    const { width } = this.state;
    const isMobile = width <= 980;
    if (isMobile) {
      return (
        <Col sm="9" md="9" xs="9" className="text-center float-left" style={{maxWidth: '300px'}}>
          <Col sm="12" md="12" xs="12" className="float-left px-0" onClick={() => {this.openUrl(this.props.platform, this.props.url)}}>
            <div className="overlay" style={{borderRadius: '0'}}></div>
            <Col xs="12" sm="12" xs="12" className={`desk_video_text_display video-background-image video-back px-0` } style={{backgroundImage: `url(${this.props.image})`, borderRadius: '0'}}>
              <Col xs="12" sm="12" md="12" className="text-left float-left overlay-div text-white">
                <Col xs="12" sm="12" md="12" className="float-left px-0 mb-1" style={{maxHeight: '45px', overflow: 'auto'}}>
                  <h6 className="mb-0" style={{color: 'rgb(255, 255, 0)'}}>{this.props.title}</h6>
                </Col>
                <h6 style={{fontWeight: '400'}}>By {this.props.author}</h6>
              </Col>
            </Col>
          </Col>
        </Col>
      );
    } else {
      return (
        <Col sm="6" md="4" lg={`${this.props.type === '' ? '3' : '4'}`} className={`text-center float-left ${this.props.type === '' ? '' : 'm-t-2'}`}>
          <Col sm="12" md="12" lg="12" className="px-0 float-left" onClick={() => {this.openUrl(this.props.platform, this.props.url)}}>
            <div className="overlay" style={{borderRadius: '0'}}></div>
            <Col xs="12" sm="12" lg="12" className={`video_desk_div video_desk_div_bg pointer desk_video_text_display`} style={{backgroundImage: `url(${this.props.image})`}}>
              <Col sm="12" md="12" lg="12" className="text-white overlay-div text-left float-left">
                <Col sm="12" md="12" lg="12" className="float-left px-0 mb-1" style={{maxHeight: '70px', overflow: 'auto'}}>
                  <h5 className="mb-0" style={{color: 'rgb(255, 255, 0)'}}> {this.props.title} </h5>
                </Col>
                <h5 style={{fontWeight: '400'}}>By {this.props.author}</h5>
              </Col>
            </Col>
          </Col>
        </Col>
      );
    }
  }
}

class Meetups extends React.Component {
  constructor(props) {
    super(props);

    this.dateFormat = this.dateFormat.bind(this);
    this.state = {
      width: window.innerWidth,
    }
  }
  componentWillUnmount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };
  openMeetup(url) {
    let uri = `/events/${url}`
    window.open(uri, '_blank')
  }
  dateFormat(value){
    let monthNames = [
      "Jan", "Feb", "Mar",
      "Apr", "May", "Jun", "Jul",
      "Aug", "Sep", "Oct",
      "Nov", "Dec"
    ];
    let date_suffix = [
      'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th',
      'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'st', 'nd', 'rd', 'th',
      'th', 'th', 'th', 'th', 'th', 'th', 'st'
    ]
    let start_date = new Date(value);
    // let node = document.createElement("sup");
    // let display_suffix = document.createTextNode(date_suffix[(start_date.getDate() - 1).toString()]);
    // let suffix = node.appendChild(display_suffix).toString()
    let display_suffix = date_suffix[(start_date.getDate() - 1).toString()];
    let date = start_date.getDate().toString()+display_suffix+' '+monthNames[start_date.getMonth().toString()]+', '+start_date.getFullYear().toString()
    return date;
  }
  render() {
    const { width } = this.state;
    const isMobile = width <= 980;
    let avatar;
    if (this.props.avatar === null) {
      avatar = REGISTER
    } else {
      avatar = this.props.avatar
    }
    if (isMobile) {
      return (
        <Col sm="9" md="9" xs="9" className="text-center float-left m-t-2" style={{maxWidth: '300px'}}>
          <Col sm="12" md="12" xs="12" className="px-0 float-left" onClick={() => {this.openMeetup(this.props.url_id)}}>
            <div className="overlay pointer" style={{borderRadius: '0'}}></div>
            <Col xs="12" sm="12" md="12" className="desk_video_text_display video-background-image video-back px-0" style={{backgroundImage: `url(${avatar})`}}>
              <Col sm="12" md="12" xs="12" className="overlay-div float-left text-left text-white">
                <Col sm="12" md="12" xs="12" className="float-left px-0 mb-1" style={{maxHeight: '45px', overflow: 'auto'}}>
                  <h6 className="mb-0" style={{color: 'rgb(255, 255, 0)'}}> {this.props.title} </h6>
                </Col>
                <h6 style={{fontWeight: '400'}}>{this.dateFormat(this.props.date)}</h6>
                <h6 style={{fontWeight: '400'}} className={this.props.city === undefined ? 'hidden' : ''}>{this.props.city}</h6>
              </Col>
            </Col>
          </Col>
        </Col>
      )
    } else {
      return (
        <Col sm="6" md="4" lg={`${this.props.type === '' ? '3' : '4'}`} className={`text-center float-left ${this.props.type === '' ? '' : 'm-t-2'}`}>
          <Col sm="12" md="12" lg="12" className="px-0 float-left" onClick={() => {this.openMeetup(this.props.url_id)}}>
            <div className="overlay pointer" style={{borderRadius: '0'}}></div>
            <Col xs="12" sm="12" lg="12" className={`video_desk_div video_desk_div_bg pointer desk_video_text_display float-left text-left text-white`} style={{backgroundImage: `url(${avatar})`}}>
              <Col sm="12" md="12" lg="12" className="overlay-div float-left text-left text-white">
                <Col sm="12" md="12" lg="12" className="float-left px-0 mb-1" style={{maxHeight: '70px', overflow: 'auto'}}>
                  <h5 className="mb-0" style={{color: 'rgb(255, 255, 0)'}}> {this.props.title} </h5>
                </Col>
                <h5 style={{fontWeight: '400'}}>{this.dateFormat(this.props.date)}</h5>
                <h5 style={{fontWeight: '400'}} className={this.props.city === undefined ? 'hidden' : ''}>{this.props.city}</h5>
              </Col>
            </Col>
          </Col>
        </Col>
      );
    }
  }
}

class AgilityThinking extends Component {
  constructor(props) {
    super(props);
    this.displayVideos = this.displayVideos.bind(this);
    this.scrollMeetupLeft = this.scrollMeetupLeft.bind(this);
    this.scrollMeetupRight = this.scrollMeetupRight.bind(this);
    this.handleMeetupScroll = this.handleMeetupScroll.bind(this);
    this.displaySoundcloud = this.displaySoundcloud.bind(this);
    this.displayMeetups = this.displayMeetups.bind(this);
    this.meetupToggle = this.meetupToggle.bind(this);
    this.webinarToggle = this.webinarToggle.bind(this);
    this.displayCities = this.displayCities.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleChangeCity = this.handleChangeCity.bind(this);
    this.displayBlogs = this.displayBlogs.bind(this);
    this.displayHoverData = this.displayHoverData.bind(this);
    this.displayParentSibling = this.displayParentSibling.bind(this);
    this.displayPtConfDiv = this.displayPtConfDiv.bind(this);
    this.displaySmTalesSeries = this.displaySmTalesSeries.bind(this);
    this.scrollToLocation = this.scrollToLocation.bind(this);
    this.displayCommunityVideo = this.displayCommunityVideo.bind(this);
    this.openContactModal = this.openContactModal.bind(this);
    this.showSpeakerContactModal = this.showSpeakerContactModal.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleSpeaker = this.toggleSpeaker.bind(this);
    this.submitSpeakerData = this.submitSpeakerData.bind(this);
    this.handleChangeSpeaker = this.handleChangeSpeaker.bind(this);
    this.checkBioWordCount = this.checkBioWordCount.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.toggleSpeakerModal = this.toggleSpeakerModal.bind(this);
    this.submitVolunteerData = this.submitVolunteerData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      width: window.innerWidth,
      blog: '',
      videos: [],
      is_404: false,
      right_vid_arrow: 'none',
      right_pmspeak_arrow: 'none',
      right_blogs_arrow: 'none',
      lp_groups: [],
      lp_events: [],
      cities: [],
      current_webinars: [],
      current_meetups: [],
      showable_current_meetups: [],
      past_meetup: [],
      showable_past_meetups: [],
      past_webinar: [],
      showable_videos: [],
      showable_podcasts: [],
      group_link: '',
      right_meetup_arrow: 'none',
      right_past_arrow: 'none',
      right_webinar_arrow: 'none',
      right_past_webinar_arrow: 'none',
      upcoming_bgcolor: 'rgb(0, 0, 0)',
      upcoming_webinar_bgcolor: 'rgb(0, 0, 0)',
      past_bgcolor: 'rgb(255, 255, 255)',
      past_webinar_bgcolor: 'rgb(255, 255, 255)',
      past_textcolor: 'rgb(0, 0, 0)',
      past_webinar_textcolor: 'rgb(0, 0, 0)',
      upcoming_textcolor: 'rgb(255, 255, 255)',
      upcoming_webinar_textcolor: 'rgb(255, 255, 255)',
      meetupDropdownOpen: false,
      city_name: 'Filter By City',
      hover_element: '',
      meetup_events_fetched: false,
      webinar_events_fetched: false,
      podcast_arrow: 'none',
      pm_speak_bucket: [],
      isVideoOpen: false,
      podcasts_fetched: false,
      speaker_contact_modal: false,
      conference_speaker: {},
      toggle_speaker: true,
      early_days_check: false,
      intermediate_check: false,
      advanced_practitioner_check: false,
      all_experiences_check: false,
      volunteer_contact_modal: false,
      volunteer: {},
    };
  }
  componentWillUnmount(){
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };
  async fetchAllVideos(){
    fetch(process.env.REACT_APP_TAG_DETAIL_API+'AgilityThinking.json').then(response => response.json()).then(data => {
      let agility_videos = Object.values(data.video_set);
      let showable_videos = [];
      if (Array.isArray(agility_videos)) {
        agility_videos.map((agility_video, index) => {
          if (agility_video.channel != 'soundcloud') {
            showable_videos.push(agility_video)
          }
        })
        this.setState({videos: agility_videos, showable_videos: showable_videos});
      }
      if (this.state.width <= 980) {
        if (showable_videos.length > 1) {
          this.setState({right_vid_arrow: 'block'})
        }
      } else {
        if (showable_videos.length > 4) {
          this.setState({right_vid_arrow: 'block'})
        }
      }
    }).catch(error => this.setState({ isLoading: false }));
  }
  async fetchPodcastDetails() {
    this.setState({ podcasts_fetched: false })
    axios.get(process.env.REACT_APP_API_HOST +'/public/podcasts/?tags=463')
      .then(res => {
        let showable_podcasts = res.data.results
        this.setState({ showable_podcasts: showable_podcasts })
        if ( showable_podcasts != undefined && showable_podcasts.length > 0 )
          this.setState({podcasts_fetched: true});
        if (this.state.width <= 980) {
          if (showable_podcasts.length > 1) {
            this.setState({podcast_arrow: 'block'})
          }
        } else {
          if (showable_podcasts.length > 4) {
            this.setState({podcast_arrow: 'block'})
          }
        }
      }).catch(error => this.setState({ isLoading: false,podcasts_fetched: false }));
  }
  async fetchSmTalesSeries() {
    fetch(process.env.REACT_APP_API_HOST+'/sprint/pmspeak/?course_id=117').then(response => response.json()).then(data => {
      let images = []
      data.map((sprint_data, index) => {
        sprint_data.buckets.forEach ( (bucket) => {
          if ((/\.(gif|jpg|jpeg|png)$/i).test(bucket.avatar)) {
            bucket.name = sprint_data.name.toLowerCase()
            images.push(bucket);
          }
        });
      })
      this.setState({pm_speak_bucket: images})
    })
  }
  async fetchGroup() {
    fetch(process.env.REACT_APP_MEETUPS_API+'?id=4').then(response => response.json()).then(data => {
      this.setState({lp_groups: data, group_link: data[0].slug})
    }).catch(error => {
     this.setState({ isLoading: false })
    });
  }
  async fetchMeetup(){
    this.setState({meetup_events_fetched: false})
    fetch(process.env.REACT_APP_API_HOST+'/pt-all-events/?meetup__id=4&event_type=1').then(response => response.json()).then(data =>{
      this.setState({ lp_events: data, meetup_events_fetched: true})
      this.sortEvents(data, 'meetup');
    }).catch(error => {
      this.setState({meetup_events_fetched: false})
    });
  }
  async fetchWebinar(){
    this.setState({webinar_events_fetched: false})
    fetch(process.env.REACT_APP_API_HOST+'/pt-all-events/?meetup__id=4&event_type=0').then(response => response.json()).then(data =>{
      this.setState({ lp_events: data, webinar_events_fetched: true})
      this.sortEvents(data, 'webinar');
    }).catch(error => {
      this.setState({webinar_events_fetched: false})
    });
  }
  async fetchCity(){
    fetch(process.env.REACT_APP_TAG_DETAIL_API+'AgilityThinking.json').then(response => response.json()).then(data => {
      this.setState({cities: data.city_set})
    }).catch(error => {
      this.setState({cities: [], isLoading: false})
    })
  }
  async fetchBlogs(){
    fetch(process.env.REACT_APP_API_HOST+'/blogs/events/?tags=463').then(response => response.json()).then(data => {
      if (this.state.width <= 980) {
        if (data.results.length > 1) {
          this.setState({right_blogs_arrow: 'block'})
        }
      } else {
        if (data.results.length > 4) {
          this.setState({right_blogs_arrow: 'block'})
        }
      }
      this.setState({blogs: data.results.reverse() })
    }).catch(error => this.setState({isLoading: false, blogs: []}));
  }
  componentDidMount(){
    this.fetchCity();
    this.fetchAllVideos();
    this.fetchGroup();
    this.fetchMeetup();
    this.fetchWebinar();
    this.fetchBlogs();
    this.fetchPodcastDetails();
    this.fetchSmTalesSeries();
    this.scrollToLocation();
  }
  displayVideos(video_name){
    let all_videos = this.state.showable_videos;
    let isVideos = (all_videos === undefined || all_videos.length === 0) ? false : true;
    if (isVideos) {
      return (
        all_videos.map((video, index) => {
          return (
            <AllVideos key={index} url={video.url} channel={video.channel} video_id={video.video_id} title={video.title} video_name={video_name} type={this.state.hover_element} is_webinar={false}/>
          );
        })
      );
    }
  }
  scrollMeetupLeft(id){
    var video_div = document.getElementById(id);
    if (video_div) {
      var flex_scroll_amount = (video_div.scrollWidth) / (video_div.childElementCount);
      var left_pos = video_div.scrollLeft;
      video_div.scrollLeft = left_pos - (3 * flex_scroll_amount);
    }
  }
  scrollMeetupRight(id){
    var video_div = document.getElementById(id);
    if (video_div) {
      var flex_scroll_amount = (video_div.scrollWidth) / (video_div.childElementCount);
      var left_pos = video_div.scrollLeft;
      video_div.scrollLeft = left_pos + (3 * flex_scroll_amount);
    }
  }
  handleMeetupScroll(event, left_arrow, right_arrow){
    var new_left_pos = event.target.scrollLeft;
    if (new_left_pos > 0) {
      if(document.querySelector(`.${left_arrow}`))document.querySelector(`.${left_arrow}`).style.display = 'inline-block';
    }
    else{
      if(document.querySelector(`.${left_arrow}`))document.querySelector(`.${left_arrow}`).style.display = 'none';
    }
    if ( (new_left_pos + event.target.offsetWidth) === event.target.scrollWidth) {
      if(document.querySelector(`.${right_arrow}`))document.querySelector(`.${right_arrow}`).style.display = 'none';
    }
    else{
      if(document.querySelector(`.${right_arrow}`))document.querySelector(`.${right_arrow}`).style.display = 'inline-block';
    }
  }
  openUrl(url){
    window.open(url)
  }
  displaySoundcloud(){
    let all_soundcloud = this.state.showable_podcasts;
    let isSoundcloud = (all_soundcloud === undefined || all_soundcloud.length === 0) ? false : true
    if (isSoundcloud) {
      return (
        all_soundcloud.map((soundcloud, index) => {
          return (
            <SoundCloudPlayer key={index} title={soundcloud.name} audio_id={soundcloud.video_id} type={this.state.hover_element} secret_token={soundcloud.secret_token}/>
          );
        })
      );
    }
  }
  sortEvents(event_data, type){
    let initial_events = event_data;
    let upcoming_events = [], past_events = [];
    let today = new Date();
    let is_events = (initial_events === undefined || initial_events.length === 0) ? false : true
    if (is_events) {
      initial_events.map((ptevent, index) => {
        if (new Date(ptevent.start_date) >= today) {
          upcoming_events.push(ptevent)
        } else {
          if (type === 'webinar') {
            if (ptevent.videos.length > 0) {
              past_events.push(ptevent)
            }
          } else if (type != 'webinar') {
            past_events.push(ptevent)
          }
        }
      })
      if (type === 'meetup') {
        let showable_past_meetups = [...past_events]
        this.setState({current_meetups: upcoming_events, past_meetup: past_events, showable_current_meetups: upcoming_events, showable_past_meetups: showable_past_meetups.reverse()})
      } else if (type === 'webinar') {
        this.setState({current_webinars: upcoming_events, past_webinar: past_events.reverse()})
      }
      if (this.state.width <= 980) {
        if (upcoming_events.length > 1) {
          if (type === 'meetup') {
            this.setState({right_meetup_arrow: 'block'})
          } else if (type === 'webinar') {
            this.setState({right_webinar_arrow: 'block'})
          }
        } else if (past_events.length > 1) {
          if (type === 'meetup') {
            this.setState({right_past_arrow: 'block'})
          } else if (type === 'webinar') {
            this.setState({right_past_webinar_arrow: 'block'})
          }
        }
      } else {
        if (upcoming_events.length > 4) {
          if (type === 'meetup') {
            this.setState({right_meetup_arrow: 'block'})
          } else if (type === 'webinar') {
            this.setState({right_webinar_arrow: 'block'})
          }
        } else if (past_events.length > 4) {
          if (type === 'meetup') {
            this.setState({right_past_arrow: 'block'})
          } else if (type === 'webinar') {
            this.setState({right_past_webinar_arrow: 'block'})
          }
        }
      }
    }
  }
  meetupToggle(event){
    event.preventDefault();
    if (event.currentTarget) {
      if (event.currentTarget.id === 'nav-upcoming-meetup') {
        this.setState({upcoming_bgcolor: 'rgb(0, 0, 0)', upcoming_textcolor: 'rgb(255, 255, 255)',
        past_bgcolor: 'rgb(255, 255, 255)', past_textcolor: 'rgb(0, 0, 0)'})
      } else {
        this.setState({upcoming_bgcolor: 'rgb(255, 255, 255)', upcoming_textcolor: 'rgb(0, 0, 0)',
        past_bgcolor: 'rgb(0, 0, 0)', past_textcolor: 'rgb(255, 255, 255)'})
      }
    }
  }
  webinarToggle(event){
    event.preventDefault();
    if (event.currentTarget) {
      if (event.currentTarget.id === 'nav-upcoming-webinar') {
        this.setState({upcoming_webinar_bgcolor: 'rgb(0, 0, 0)', upcoming_webinar_textcolor: 'rgb(255, 255, 255)',
        past_webinar_bgcolor: 'rgb(255, 255, 255)', past_webinar_textcolor: 'rgb(0, 0, 0)'})
      } else {
        this.setState({upcoming_webinar_bgcolor: 'rgb(255, 255, 255)', upcoming_webinar_textcolor: 'rgb(0, 0, 0)',
        past_webinar_bgcolor: 'rgb(0, 0, 0)', past_webinar_textcolor: 'rgb(255, 255, 255)'})
      }
    }
  }
  displayMeetups(value) {
    const {width} = this.state;
    let upcoming_meetup = this.state.showable_current_meetups;
    let past_meetup = this.state.showable_past_meetups;
    let is_upcoming_meetup = (upcoming_meetup === undefined || upcoming_meetup.length === 0) ? false : true;
    let is_past_meetup = (past_meetup === undefined || past_meetup.length === 0) ? false : true;
    if (this.state.meetup_events_fetched) {
      if (value === 'upcoming') {
        if (is_upcoming_meetup) {
          return (
            upcoming_meetup.map((meetup, index) => {
              return (
                <Meetups key={index} title={meetup.title} date={meetup.start_date} city={meetup.city === undefined ? undefined : meetup.city} url_id={meetup.slug} type={this.state.hover_element} avatar={meetup.avatar}/>
              );
            })
          );
        } else {
          if (this.state.hover_element === '') {
            return (
              <div className={`animated fadeIn pt-1 center ${width <= 980 ? 'text-center' : 'text-center'}`} style={{fontSize: width <= 980 ? '1.2rem' : '2rem'}}>Awesome meetups will be here soon!</div>
            );
          } else {
            return (
              <div className="animated fadeIn pt-1 center text-white text-center" style={{fontSize: '2rem'}}>Awesome meetups will be here soon!</div>
            );
          }
        }
      } else {
        if (is_past_meetup) {
          return (
            past_meetup.map((meetup, index) => {
              return (
                <Meetups key={index} title={meetup.title} date={meetup.start_date} city={meetup.city === undefined ? undefined : meetup.city} url_id={meetup.slug} type={this.state.hover_element} avatar={meetup.avatar}/>
              );
            })
          );
        } else {
          return (
            <div className={`animated fadeIn pt-1 center ${width <= 980 ? 'text-center' : 'center'}`} style={{fontSize: width <= 980 ? '1.2rem' : '2rem'}}>Sorry!!! No Meetup Found</div>
          );
        }
      }
    } else {
      return (
        <Col xs="12" className="text-center">
          <Loader
            type="Puff"
            color="#00BFFF"
            height={100}
            width={100}
          />
        </Col>
      );
    }
  }
  displayWebinars(value) {
    const {width} = this.state;
    let upcoming_webinar = this.state.current_webinars;
    let past_webinar = this.state.past_webinar;
    let is_upcoming_webinar = (upcoming_webinar === undefined || upcoming_webinar.length === 0) ? false : true;
    let is_past_webinar = (past_webinar === undefined || past_webinar.length === 0) ? false : true;
    if (this.state.webinar_events_fetched) {
      if (value === 'upcoming') {
        if (is_upcoming_webinar) {
          return (
            upcoming_webinar.map((webinar, index) => {
              return (
                <Meetups key={index} title={webinar.title} date={webinar.start_date} city={webinar.city === undefined ? undefined : webinar.city} url_id={webinar.slug} type={this.state.hover_element} avatar={webinar.avatar}/>
              );
            })
          );
        } else {
          if (this.state.hover_element === '') {
            return (
              <div className={`animated fadeIn pt-1 ${width <= 980 ? 'center' : 'center'}`} style={{fontSize: width <= 980 ? '1.2rem' : '2rem'}}>Awesome webinars will be here soon!</div>
            );
          } else {
            return (
              <div className="animated fadeIn pt-1 center text-white" style={{fontSize: '2rem'}}>Awesome webinars will be here soon!</div>
            );
          }
        }
      } else {
        if (is_past_webinar) {
          return (
            past_webinar.map((webinar, index) => {
              if (webinar.videos.length > 0) {
                return (
                  webinar.videos.map((video, video_index) => {
                    return (
                      <AllVideos key={video_index} url={video.url} channel={video.channel} video_id={video.video_id} title={video.title} video_name='past_webinar' type={this.state.hover_element} is_webinar={true} date={webinar.start_date}/>
                    );
                  })
                );
              }
            })
          );
        } else {
          return (
            <div className={`animated fadeIn pt-1 ${width <= 980 ? 'center' : 'center'}`} style={{fontSize: width <= 980 ? '1.2rem' : '2rem'}}>Sorry!!! No Webinars Found</div>
          );
        }
      }
    } else {
      return (
        <Col xs="12" className="text-center">
          <Loader
            type="Puff"
            color="#00BFFF"
            height={100}
            width={100}
          />
        </Col>
      );
    }
  }
  displayCities(){
    let cities = this.state.cities;
    let is_cities = (cities === undefined || cities.length === 0) ? false : true;
    if (is_cities) {
      return (
        cities.map((city, index) => {
          return (
            <DropdownItem key={index} value={city.name} onClick={(e) => {this.handleChangeCity(e)}}>{city.name}</DropdownItem>
          );
        })
      );
    }
  }
  toggle(){
    this.setState({meetupDropdownOpen: !this.state.meetupDropdownOpen})
  }
  handleChangeCity(event){
    event.preventDefault();
    this.setState({right_meetup_arrow: 'none', right_past_arrow: 'none', showable_current_meetups: [], showable_past_meetups: []})
    let upcoming_meetup = this.state.current_meetups;
    let past_meetup = this.state.past_meetup;
    let is_upcoming_meetup = (upcoming_meetup === undefined || upcoming_meetup.length === 0) ? false : true;
    let is_past_meetup = (past_meetup === undefined || past_meetup.length === 0) ? false : true;
    if (event.target.value) {
      let current_meetups = [], past_meetups = [];
      let past_events = [...this.state.past_meetup]
      this.setState({city_name: event.target.value})
      if (event.target.value === 'Filter By City') {
        this.setState({showable_current_meetups: this.state.current_meetups, showable_past_meetups: past_events.reverse()})
        if (upcoming_meetup.length > 4) {
          this.setState({right_meetup_arrow: 'block'})
        }
        if (past_meetup.length > 4) {
          this.setState({right_past_arrow: 'block'})
        }
      } else {
        upcoming_meetup.map((upmeetup, upindex) => {
          if (upmeetup.city === event.target.value) {
            current_meetups.push(upmeetup)
          }
        })
        past_meetup.map((pmeetup, pindex) => {
          if (pmeetup.city === event.target.value) {
            past_meetups.push(pmeetup)
          }
        })
        let showable_past_meetups = [...past_meetups]
        if (current_meetups.length > 4) {
          this.setState({right_meetup_arrow: 'block'})
        }
        if (past_meetups.length > 4) {
          this.setState({right_past_arrow: 'block'})
        }
        this.setState({showable_current_meetups: current_meetups, showable_past_meetups: showable_past_meetups.reverse()})
      }
    }
  }
  displayBlogs(){
    const {width} = this.state;
    let blogs = this.state.blogs;
    let is_blog = (blogs === undefined || blogs.length === 0) ? false : true;
    if (is_blog) {
      return (
        blogs.map((blog, index) => {
          return (
            <Blogs key={index} image={blog.avatar} title={blog.title} author={blog.author === "" ? blog.trainer : blog.author} url={blog.slug} type={this.state.hover_element} platform={blog.is_medium_blog === true ? true : false}/>
          );
        })
      );
    }else {
      if (this.state.hover_element === '') {
        return (
          <div className={`animated fadeIn pt-1 ${width <= 980 ? 'center' : 'center'}`} style={{fontSize: width <= 980 ? '1.2rem' : '2rem'}}>Awesome blogs will be here soon!</div>
        );
      } else {
        return (
          <div className="animated fadeIn pt-1 center text-white" style={{fontSize: '2rem'}}>Awesome blogs will be here soon!</div>
        );
      }
    }
  }
  displayParentSibling(event){
    event.preventDefault();
    let headingclass = document.getElementsByClassName('agility_event');
    if (headingclass) {
      for (var i = 0; i < headingclass.length; i++) {
        headingclass[i].style.background = 'transparent';
        headingclass[i].style.color = 'rgb(255, 255, 255)';
      }
    }
    if (event.currentTarget) {
      this.setState({hover_element: event.currentTarget.id})
      let parent_element = event.currentTarget.parentElement.parentElement;
      if (parent_element) {
        let sibling_element = parent_element.nextElementSibling;
        if (sibling_element) {
          sibling_element.style.display = 'block';
          if (sibling_element.style.display === 'block') {
            event.currentTarget.style.background = 'rgb(255, 255, 0)';
            event.currentTarget.style.color = 'rgb(0, 0, 0)';
          }
        }
      }
    }
  }
  displayPtConfDiv(event) {
    event.preventDefault()
    let headingclass = document.getElementsByClassName('agility_event');
    let headingclassdata = document.getElementById('agility_event_data');
    this.setState({hover_element: ''})
    if (headingclass) {
      for (var i = 0; i < headingclass.length; i++) {
        headingclass[i].style.background = 'transparent';
        headingclass[i].style.color = 'rgb(255, 255, 255)';
      }
    }
    if (headingclassdata) {
      headingclassdata.style.display = "none";
    }
  }
  displayHoverData(){
    let hover_element = this.state.hover_element;
    if (hover_element != '') {
      if (hover_element === 'meetup') {
        return this.displayMeetups('upcoming')
      }else if (hover_element === 'webinar') {
        return this.displayWebinars('upcoming');
      }else if (hover_element === 'video') {
        return this.displayVideos('video');
      }else if (hover_element === 'pm') {
        return this.displaySmTalesSeries();
      }else if (hover_element === 'blog') {
        return this.displayBlogs();
      }else if (hover_element === 'podcasts') {
        return this.displaySoundcloud();
      }
    }
  }
  displaySmTalesSeries(){
    let pm_series = this.state.pm_speak_bucket;
    let is_pm_series = (pm_series === undefined || pm_series.length === 0) ? false : true;
    if (is_pm_series) {
      return (
        pm_series.map((series, index) =>{
          return (
            <SmSeries key={index} avatar={series.avatar} name={series.name} type={this.state.hover_element}/>
          );
        })
      );
    }
  }
  scrollToLocation() {
    let location_hash = window.location.hash;
    if (location_hash) {
      location_hash = location_hash.replace('#', '.');
      let location_click = document.querySelector(location_hash)
      if (location_click) {
        setTimeout(function() {
          location_click.click();
        },2000);
      }
    }
  }
  displayCommunityVideo() {
    return(
      <iframe style={{minHeight: this.state.width <= 980 ? '220px' : '300px'}}
        src={`https://player.vimeo.com/video/393377947?muted=1&autoplay=${this.state.width <= 980 ? '0' : '1'}&loop=1`}
        frameBorder="0"
        allow="autoplay">
      </iframe>
    )
  }
  openContactModal() {
    let contact_modal = document.getElementById('contact_modal')
    if (contact_modal) {
      contact_modal.click()
    }
  }
  showSpeakerContactModal() {
    return(
      <SystemModal zIndex="996" modalClassName="speaker_contact_modal" style={{marginTop: this.state.width <= 980 ? '5rem' : '7rem'}} isOpen={this.state.speaker_contact_modal} toggle={(e) => {this.toggleModal(e)}}>
        <Col xs="6" sm="6" md="6" lg="4" className="p-3" style={{backgroundColor: '#22abe1',boxShadow: '-1px -1px 5px 1px #444242'}}>
          <h3 className="text-white m-0"> Be A</h3>
          <h1 className="text-white m-0"> Speaker</h1>
        </Col>
        <i className="fa fa-close pointer overlay-div speaker_contact_modal_close_btn" aria-hidden="true" onClick={(e) => {this.toggleModal(e)}} style={{fontSize: '2rem', position: 'absolute', right: '1rem',color: '#22abe1'}}></i>
        <Col md="12" sm="12" className="text-center pb-4 px-0 mx-auto mt-3">
          <Col xs="12" sm="12" md="12" className={`text-center mb-3`}>
            <Button color={this.state.toggle_speaker == true ? "primary":"secondary"} className="col-6 speaker-form-title-button" onClick={() => {this.toggleSpeaker(true)}} >Your Details</Button>
            <Button color={this.state.toggle_speaker == false ? "primary":"secondary"} className="col-6 speaker-form-title-button" onClick={() => {this.toggleSpeaker(false)}} >Session Details</Button>
          </Col>
          <Form onSubmit={ (e) => {this.submitSpeakerData(e)} }>
            <FormGroup row className={`col-12 center referal-form ${this.state.toggle_speaker == true ? '' : 'hidden'} ${this.state.width <= 980 ? 'px-0' : ''}`}>
              <Col sm="6" md="6" lg="6" className="float-left">
                <Col md="12" className="p-0">
                  <FormGroup row className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 mt-1 text-left">
                      <Label htmlFor="name" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Name<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="text" name="name" defaultValue={this.state.conference_speaker.name} onChange={this.handleChangeSpeaker} id="speaker_name" placeholder="Name" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.name == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>Name is required !</p>
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0">
                  <FormGroup row className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 mt-1 text-left">
                      <Label htmlFor="phone" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Phone Number<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="tel" name="phone" defaultValue={this.state.conference_speaker.phone} onChange={this.handleChangeSpeaker} id="speaker_phone" placeholder="Phone Number" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.phone == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>Phone no is required !</p>
                      <p className={`${this.state.phone == false && this.state.incorrect_number_format ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>Please enter valid phone no !</p>
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0">
                  <FormGroup row className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 mt-1 text-left">
                      <Label htmlFor="email" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Email<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="text" name="email" defaultValue={this.state.conference_speaker.email} onChange={this.handleChangeSpeaker} id="speaker_email" placeholder="Email" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.email == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>Email is required !</p>
                      {/*<p className={`${ (this.state.conference_speaker.email != undefined && this.state.conference_speaker.email.indexOf("@") == -1 ? '' :'hidden')}`} style={{color: 'red'}}>please Enter valid Email !</p>*/}
                      <p className={`${this.state.email == false && this.state.incorrect_mail_format == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>Please Enter valid Email !</p>
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0">
                  <FormGroup row className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 mt-1 text-left">
                      <Label htmlFor="organisation" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Organization<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="text" name="organisation" defaultValue={this.state.conference_speaker.organisation} onChange={this.handleChangeSpeaker} id="speaker_organisation" placeholder="Organization" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.organisation == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>Organization is required !</p>
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0">
                  <FormGroup row className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 mt-1 text-left">
                      <Label htmlFor="designation"  className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Designation<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="text" name="designation" defaultValue={this.state.conference_speaker.designation} onChange={this.handleChangeSpeaker} id="speaker_designation" placeholder="Designation" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.designation == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>Designation is required !</p>
                    </Col>
                  </FormGroup>
                </Col>
              </Col>
              <Col sm="6" md="6" lg="6" className="float-left">
                <Col md="12" className="p-0">
                  <FormGroup row className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 mt-1 text-left">
                      <Label htmlFor="linkedin" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>LinkedIn<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="text" name="linkedin_url" defaultValue={this.state.conference_speaker.linkedin_url} onChange={this.handleChangeSpeaker} id="speaker_linkedin" placeholder="LinkedIn" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.linkedin_url == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>This field should not be empty !</p>
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0">
                  <FormGroup row className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 mt-1 text-left">
                      <Label htmlFor="twitter" className="mb-0" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Twitter<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="text" name="twitter_url" defaultValue={this.state.conference_speaker.twitter_url} onChange={this.handleChangeSpeaker} id="speaker_twitter" placeholder="Twitter" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.twitter_url == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>This field should not be empty !</p>
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0">
                  <FormGroup row className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 mt-1 text-left">
                      <Label htmlFor="city" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>City<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="text" name="city" defaultValue={this.state.conference_speaker.city} onChange={this.handleChangeSpeaker} id="speaker_city" placeholder="City" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.city == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>This field should not be empty !</p>
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0">
                  <FormGroup row className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 mt-1 text-left">
                      <Label htmlFor="country" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Country<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="text" name="country" defaultValue={this.state.conference_speaker.country} onChange={this.handleChangeSpeaker} id="speaker_country" placeholder="Country" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.country == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>This field should not be empty !</p>
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0 mt-4">
                  <FormGroup row className="mx-auto mb-3" style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 text-left">
                      <Label htmlFor="short_biography" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Short Bio<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9" className="pl-0">
                      <Input className="" type="textarea" name="short_biography" defaultValue={this.state.conference_speaker.short_biography} onChange={this.handleChangeSpeaker} rows={3} id="speaker_short_biography" placeholder="Short Bio (150 - 300 Words)" style={{boxShadow: 'none', padding: '0px 5px'}}  maxLength={300} minLength={150}/>
                      <p className={`${this.state.short_biography == true ? '' : 'hidden'}`} style={{color: 'red', margin: '2px 0px'}}>Please fill your short biography</p>
                      <p className={`${this.state.short_biography == false && this.state.min_length_short_biography ? '' : 'hidden'}`} style={{color: 'red'}}>Min 150 words needed.</p>
                    </Col>
                  </FormGroup>
                </Col>
              </Col>
            </FormGroup>
            <FormGroup row className={`col-12 center referal-form ${this.state.toggle_speaker == false ? '' : 'hidden'}`}>
              <Col sm="6" md="6" lg="6" className="float-left">
                <Col md="12" className="p-0">
                  <FormGroup className="mx-auto mb-3 " style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className=" mt-1 px-0 text-left">
                      <Label htmlFor="session_title" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Session Title<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9">
                      <Input className="" type="text" name="session_title" defaultValue={this.state.conference_speaker.session_title} onChange={this.handleChangeSpeaker} id="speaker_session_title" placeholder="Session Title" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0 mt-4">
                  <FormGroup className="mx-auto mb-3" style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 text-left">
                      <Label htmlFor="session_summary" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Session Summary<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9">
                      <Input className="" type="textarea" rows="3" name="session_summary" defaultValue={this.state.conference_speaker.session_summary} onChange={this.handleChangeSpeaker} id="speaker_session_summary" placeholder="Session Summary" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0 text-left">
                  <FormGroup className="mx-auto mb-3" style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 text-left">
                      <Label htmlFor="target_audience" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Target Audience<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9">
                      <div style={{color: '#5c6873'}}>
                        <CustomInput type="checkbox" name="early_days_check" value={this.state.early_days_check} checked={this.state.early_days_check} id="early_days·" label="Early Days·" onChange={this.toggleCheckbox}/>
                        <CustomInput type="checkbox" name="intermediate_check" value={this.state.intermediate_check} checked={this.state.intermediate_check} id="intermediate" label="Intermediate" onChange={this.toggleCheckbox}/>
                        <CustomInput type="checkbox" name="advanced_practitioner_check" value={this.state.advanced_practitioner_check} checked={this.state.advanced_practitioner_check} id="advanced_practitioner·" label="Advanced Practitioner·" onChange={this.toggleCheckbox} />
                        <CustomInput type="checkbox" name="all_experiences_check" value={this.state.all_experiences_check} checked={this.state.all_experiences_check} id="all_experiences" label="All Experience Levels·" onChange={this.toggleCheckbox} />
                        <p className={`mt-3 ${this.state.target_audience_selected == false ? '' : 'hidden'}`} style={{color: 'red'}}>Please select target audience!</p>
                      </div>
                    </Col>
                  </FormGroup>
                </Col>
              </Col>
              <Col sm="6" md="6" lg="6" className="float-left">
                <Col md="12" className="p-0">
                  <FormGroup className="mx-auto mb-3" style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 text-left">
                      <Label htmlFor="session_description" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Session Description<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9">
                      <Input className="" type="textarea" rows="3" name="session_description" defaultValue={this.state.conference_speaker.session_description} onChange={this.handleChangeSpeaker} id="speaker_session_description" placeholder="Session Description" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0">
                  <FormGroup className="mx-auto mb-3" style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 text-left">
                      <Label htmlFor="learning_objectives" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>Learning Objectives for Audience<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9">
                      <Input className="" type="textarea" rows="3" name="learning_objectives" defaultValue={this.state.conference_speaker.learning_objectives} onChange={this.handleChangeSpeaker} id="speaker_learning_objectives" placeholder="Learning Objectives for Audience" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md="12" className="p-0">
                  <FormGroup className="mx-auto mb-3" style={{display: 'flex'}}>
                    <Col xs="4" sm="4" md="4" lg="3" className="px-0 text-left">
                      <Label htmlFor="conference_experience" className="mb-0"><h6 className="mb-0" style={{fontWeight: 400}}>References to Your Speaking Ability (Videos, ppt, etc.)<span style={{color: 'rgb(255, 0, 0)', fontSize: 'large'}}>*</span></h6></Label>
                    </Col>
                    <Col xs="8" sm="8" md="8" lg="9">
                      <Input className="" type="textarea" rows="3" name="conference_experience" defaultValue={this.state.conference_speaker.conference_experience} onChange={this.handleChangeSpeaker} id="speaker_conference_experience" placeholder="References to Your Speaking Ability (Videos, ppt, etc.)" style={{boxShadow: 'none', padding: '0px 5px'}} required />
                      <p className={`${this.state.conference_experience == true ? '' : 'hidden'}`} style={{color: 'red'}}>Please fill your Conference Experience/References...</p>
                    </Col>
                  </FormGroup>
                </Col>
              </Col>
            </FormGroup>
            <Col md="10" className="padding-top-20 referal-form center">
              <Button type="submit" color="primary" className={`mb-2 btn m-l-10 py-2 px-5 ${this.state.toggle_speaker ? 'hidden' : ''}`} style={{fontSize: '18px'}}>Submit</Button>
              <Button color="primary" className={`mb-2 btn m-l-10 py-2 px-5 ${!this.state.toggle_speaker ? 'hidden' : ''}`} onClick={() => {this.toggleSpeaker(false)}} style={{fontSize: '18px'}}>Next</Button>
            </Col>
          </Form>
        </Col>
      </SystemModal>
    )
  }
  toggleModal(event,value) {
    if (event != null) {
      if (event.currentTarget.className.indexOf("speaker_contact_modal") != -1) {
        this.setState({ speaker_contact_modal : !this.state.speaker_contact_modal });
      }
      if (event.currentTarget.className.indexOf("volunteer_contact_modal") != -1) {
        this.setState({ volunteer_contact_modal : !this.state.volunteer_contact_modal });
      }
    } else {
      let modal = value.replace("_submit_btn", "");
      this.setState({ [modal] : !this.state[modal] });
    }
  }
  toggleSpeaker(value) {
    let toggle_speaker = true;
    let invalid_email, invalid_number, left_short_bio_length, short_bio_length
    if (value == false) {
      let fields = ["name","phone","email","organisation","designation","linkedin_url","twitter_url","city","country","short_biography"]
      for (var i = 0; i < fields.length; i++) {

        // checking whether the fields are empty or not
        this.setState({[fields[i]]: false})
        if ( (this.state.conference_speaker[fields[i]] == undefined || this.state.conference_speaker[fields[i]] == '') && toggle_speaker == true) {
          this.setState({[fields[i]]: true})
          toggle_speaker =false;
        }

        // for valid email address
        if ( (fields[i] == "email" && this.state.conference_speaker.email != undefined) && this.state.conference_speaker.email.indexOf("@") == -1) {
          invalid_email = true
          toggle_speaker =false;
        } else if ( (fields[i] == "email" && this.state.conference_speaker.email != undefined) && this.state.conference_speaker.email.indexOf("@") != -1) {
          invalid_email = false
        }

        //for valid phone number
        if ((fields[i] === 'phone' && this.state.conference_speaker.phone != undefined) && isNaN(this.state.conference_speaker.phone)) {
          invalid_number = true
          toggle_speaker = false;
        }else if((fields[i] === 'phone' && this.state.conference_speaker.phone != undefined) && !isNaN(this.state.conference_speaker.phone)){
          invalid_number = false
        }

        //for short biography
        if ((fields[i] === 'short_biography' && this.state.conference_speaker.short_biography != undefined) && this.state.conference_speaker.short_biography.length < 150) {
          short_bio_length = true
          left_short_bio_length = 150 - this.state.conference_speaker.short_biography.length
          toggle_speaker = false;
        } else if ((fields[i] === 'short_biography' && this.state.conference_speaker.short_biography != undefined) && this.state.conference_speaker.short_biography.length >= 150) {
          short_bio_length = false
        }

      }
    } else {
      this.setState({toggle_speaker: value}) //when we click on your details
    }

    if (toggle_speaker == true) {
      this.setState({toggle_speaker: value}) //when click on next or session details
    }

    // checks the return value of email id format
    if (invalid_email == true) {
      this.setState({incorrect_mail_format: true})
    } else if (invalid_email == false) {this.setState({incorrect_mail_format: false})}

    //checks the return value of phone number format
    if (invalid_number) {
      this.setState({incorrect_number_format: true})
    }else if (!invalid_number) {
      this.setState({incorrect_number_format: false})
    }

    //checks the return value of short bio length
    if (short_bio_length) {
      this.setState({min_length_short_biography: true})
    } else if (!short_bio_length) {
      this.setState({min_length_short_biography: false})
    }
  }
  submitSpeakerData(event) {
    event.preventDefault();
    let conference_speaker = this.state.conference_speaker;
    // for audience type checkboxes
    let audience_type_value = (this.state.early_days_check == true ? "Early Days." : "") + (this.state.intermediate_check == true ? " Intermediate." : "") + (this.state.advanced_practitioner_check == true ? " Advanced Practitioner." : "") + (this.state.all_experiences_check == true ? " All Experiences" : "");
    if (audience_type_value == '') {
      this.setState({target_audience_selected: false})
    }else {
      this.setState({target_audience_selected: true})
      var formData = new FormData();
      for(var k in conference_speaker) {
        formData.append(k, conference_speaker[k])
      }
      formData.append("audience_type",audience_type_value.split('.').join(' ,'))
      formData.append("platform_type",'1')

      axios.post(process.env.REACT_APP_API_HOST+'/conference_speakers/', formData,)
        .then(response => {
          hideMessage.displaySuccessMsg('Thank you for your interest! Our team will contact you shortly!')
          this.setState({ speaker_contact_modal: !this.state.speaker_contact_modal });
        }).catch(error => {
          let error_messages = ''
          for (var key in error.response.data){
            error_messages += error.response.data[key] + "<br>"
          }
          hideMessage.displayErrorMsg(error_messages)
        });
    }
  }
  handleChangeSpeaker(event){
    let someProperty = {...this.state.conference_speaker}
    if(event.target){
      someProperty[event.target.name] = event.target.value
      if (event.target.name == 'short_biography') {
        this.checkBioWordCount(event.target.value)
      }
    }
    this.setState({conference_speaker: someProperty})
  }
  checkBioWordCount(description) {
    let short_bio_length
    if ( description != undefined && description.length < 150) {
      short_bio_length = true;
    } else if (description != undefined && description.length >= 150) {
      short_bio_length = false
    }
    if (short_bio_length) {
      this.setState({min_length_short_biography: true, short_biography: false})
    } else if (!short_bio_length) {
      this.setState({min_length_short_biography: false})
    }
  }
  toggleCheckbox(event){
    let name = event.target.name
    this.setState({[name]: !this.state[event.target.name]})
  }
  toggleSpeakerModal(event) {
    event.preventDefault()
    if (event.target) {
      let event_id = event.target.id
      if (event_id === 'be_a_speaker') {
        this.setState({speaker_contact_modal: !this.state.speaker_contact_modal})
      }else {
        this.setState({volunteer_contact_modal: !this.state.volunteer_contact_modal})
      }
    }
  }
  showVolunteerContactModal() {
    return(
      <SystemModal zIndex="996" modalClassName="volunteer_contact_modal" style={{marginTop: this.state.width <= 980 ? '5rem' : '7rem'}} isOpen={this.state.volunteer_contact_modal} toggle={(e) => {this.toggleModal(e)}}>
      <Col xs="6" sm="6" md="6" lg="5" className="p-3" style={{backgroundColor: '#22abe1',boxShadow: '-1px -1px 5px 1px #444242'}}>
        <h3 className="text-white m-0"> Be A</h3>
        <h1 className="text-white m-0"> Volunteer</h1>
      </Col>
        <i className="fa fa-close pointer overlay-div volunteer_contact_modal_close_btn" aria-hidden="true" onClick={(e) => {this.toggleModal(e)}} style={{fontSize: '2rem', position: 'absolute', right: '1rem',color: '#22abe1'}}></i>
        <Col md="12" sm="12" className="text-center pl-2 pr-0 pb-4 mx-auto mt-4">
          <p className="px-3 m-0" style={{textAlign: 'left', fontSize: '1rem'}}>Join the organising team of Agility thinking community.</p>
          <p className="px-3 mt-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>Eligibility for becoming a Agility Thinking Leader </p>
          <p className="px-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>- Attend atleast 8 meetups</p>
          <p className="px-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>- Present in one meet-up and a webinar</p>
          <p className="px-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>- Write 4 blogs on our platform</p>
          <p className="px-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>- Actively engage on social media with agility thinking handles</p>
          <p className="px-3 mt-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>Benefits:</p>
          <p className="px-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>- Free entry to our conferences and paid meetups</p>
          <p className="px-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>- One free workshop a year</p>
          <p className="px-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>- Recognition as a leader on our website</p>
          <p className="px-3 m-0" style={{textAlign: 'left',fontSize: 'small'}}>- Access to our coaches anytime</p>
          <Form onSubmit={(e) => {this.submitVolunteerData(e,"volunteer_contact_modal_submit_btn")}}>
            <FormGroup row className="col-12 center referal-form">
              <Col md="12" className="p-0">
                <FormGroup>
                  <Input className="p-0" type="text" name="name" defaultValue={this.state.volunteer.name} onChange={this.handleChange} id="volunteer_name" placeholder="Name" style={{boxShadow: 'none',border:'none',borderBottom: '1px solid #000000',borderRadius: '0',margin: 'auto',fontSize:'18px'}} required />
                </FormGroup>
              </Col>
              <Col md="12" className="p-0">
                <FormGroup>
                  <Input className="p-0" type="tel" name="mobile" defaultValue={this.state.volunteer.mobile} onChange={this.handleChange} id="volunteer_mobile" placeholder="Phone" style={{boxShadow: 'none',border:'none',borderBottom: '1px solid #000000',borderRadius: '0',margin: 'auto',fontSize:'18px'}} required />
                </FormGroup>
              </Col>
              <Col md="12" className="p-0">
                <FormGroup>
                  <Input className="p-0" type="text" name="email" defaultValue={this.state.volunteer.mail} onChange={this.handleChange} id="volunteer_email" placeholder="Email" style={{boxShadow: 'none',border:'none',borderBottom: '1px solid #000000',borderRadius: '0',margin: 'auto',fontSize:'18px'}} required />
                </FormGroup>
              </Col>
              <Col md="12" className="p-0">
                <FormGroup>
                  <Input className="p-0" type="text" name="organisation" defaultValue={this.state.volunteer.organisation} onChange={this.handleChange} id="volunteer_organisation" placeholder="Organisation" style={{boxShadow: 'none',border:'none',borderBottom: '1px solid #000000',borderRadius: '0',margin: 'auto',fontSize:'18px'}} required />
                </FormGroup>
              </Col>
              <Col md="12" className="p-0">
                <FormGroup>
                  <Input className="p-0" type="text" name="designation" defaultValue={this.state.volunteer.designation} onChange={this.handleChange} id="volunteer_designation" placeholder="Designation" style={{boxShadow: 'none',border:'none',borderBottom: '1px solid #000000',borderRadius: '0',margin: 'auto',fontSize:'18px'}} required />
                </FormGroup>
              </Col>
              <Col md="12" className="p-0">
                <FormGroup>
                  <Input className="p-0" type="text" name="linkedin_url" defaultValue={this.state.volunteer.linkedin_url} onChange={this.handleChange} id="volunteer_linkedin" placeholder="Linkedin" style={{boxShadow: 'none',border:'none',borderBottom: '1px solid #000000',borderRadius: '0',margin: 'auto',fontSize:'18px'}} required />
                </FormGroup>
              </Col>
              <Col md="12" className="p-0">
                <FormGroup>
                  <Input className="p-0" type="text" name="twitter_url" defaultValue={this.state.volunteer.twitter_url} onChange={this.handleChange} id="volunteer_twitter" placeholder="Twitter" style={{boxShadow: 'none',border:'none',borderBottom: '1px solid #000000',borderRadius: '0',margin: 'auto',fontSize:'18px'}} required />
                </FormGroup>
              </Col>
              <Col md="12" className="p-0">
                <FormGroup>
                  <Input className="p-0" type="textarea" rows="3" name="community_experience" defaultValue={this.state.volunteer.community_experience} onChange={this.handleChange} id="volunteer_experience" placeholder="Prior Experience with Community" style={{boxShadow: 'none',border:'none',borderBottom: '1px solid #000000',borderRadius: '0',margin: 'auto',fontSize:'18px'}} required />
                </FormGroup>
              </Col>
            </FormGroup>
            <Col md="10" className="padding-top-20 referal-form center">
              <Button type="submit" color="primary" className="mb-2 btn m-l-10 py-2 px-5" style={{fontSize: '18px'}}>Submit</Button>
            </Col>
          </Form>
          {/*<p className="px-3" style={{textAlign: 'left'}}>* Applications for volunteers is closed. Don’t worry, you can still apply and be a part of our next conference.</p>*/}
        </Col>
      </SystemModal>
    )
  }
  submitVolunteerData(event, value){
    event.preventDefault();
    if (this.state.volunteer.email){
      let email = this.state.volunteer.email;
      let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/;
      if (email.match(mailformat)) {
        var string_data = {
          email: this.state.volunteer.email,
          name: this.state.volunteer.name,
          phone: this.state.volunteer.mobile,
          organisation: this.state.volunteer.organisation,
          designation: this.state.volunteer.designation,
          linkedin_url: this.state.volunteer.linkedin_url,
          twitter_url: this.state.volunteer.twitter_url,
          community_experience: this.state.volunteer.community_experience,
          volunteer_platform_type: '1',
        }
        let formData = new FormData();
        for(var k in string_data){
          formData.append(k,string_data[k])
        }
        axios.post(process.env.REACT_APP_API_HOST+'/conference_volunteers/', formData,)
        .then(res => {
          hideMessage.displaySuccessMsg('Thank you for your interest! Our team will contact you shortly!')
          this.setState({volunteer: {}});
          this.toggleModal(null,value)
        }).catch(error => {
          hideMessage.displayErrorMsg(error)
        });
      } else {
        hideMessage.displayErrorMsg('Please provide valid email id!')
      }
    }
  }
  handleChange(event){
    let someProperty = {...this.state.volunteer}
    if(event.target){
      someProperty[event.target.name] = event.target.value
    }
    this.setState({volunteer: someProperty})
  }
  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>
  render() {
    const { width } = this.state;
    const isMobile = width <= 980;
    const { is_404 } = this.state;
    let bgimage = '', minHeight = '';
    let orientation_matches = false;
    let orientation = window.matchMedia("(orientation:landscape)")
    if (orientation.matches) {
      bgimage = PRODUCTDESKIMAGE
      minHeight = ''
    } else {
      bgimage = PRODUCTMOBIMAGE
      minHeight = 'calc(100vh - 4rem)'
    }
    if (is_404) {
      return (
        <Page404 />
      );
    }
    else if (isMobile){
      return (
        <Row className="animated fadeIn mb-2 m-t-4">
          <Row className="mx-auto w-100 text-white px-0" style={{backgroundImage: `url(${bgimage})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', minHeight: minHeight, position: 'relative'}}>
            <div className="overlay" style={{borderRadius: '0', background: 'rgba(0, 0, 0, 0.20)'}}></div>
            <Col sm="6" md="4" xs="7" className="float-left px-0 overlay-div" id="mob_agility_event">
              <Col sm="12" md="12" lg="12" className="float-left pr-0 py-3">
                <a className="agility_meetup text-white" href="#agility_meetup"><h4>Meetups</h4></a>
                <a className="agility_webinar text-white" href="#agility_webinar"><h4>Webinars</h4></a>
                <a className="agility_video text-white" href="#agility_video"><h4>Videos</h4></a>
                <a className="agility_pmvideo text-white" href="#agility_pmvideo"><h4>SM Tales Series</h4></a>
                <a className="agility_blog text-white" href="#agility_blog"><h4>Blogs</h4></a>
                <a className="agility_podcasts text-white" href="#agility_podcasts"><h4>Podcasts</h4></a>
                <h4 className="pointer" id="be_a_speaker" onClick={(e) => {this.toggleSpeakerModal(e)}}>Be A Speaker</h4>
                <h4 className="pointer" id="be_a_volunteer" onClick={(e) => {this.toggleSpeakerModal(e)}}>Be A Volunteer</h4>
                <a className="text-white" href="about-us" target="_blank"><h4>About Us</h4></a>
                <h4 className="pointer text-white" onClick={this.openContactModal}>Contact Us</h4>
              </Col>
            </Col>
          </Row>
          <Col sm="12" md="12" xs="12" className="float-left text-white px-0 pb-5" style={{backgroundColor: `rgb(1, 19, 29)`}}>
            <h1 className="flora text-center pt-5 mb-0" style={{color: 'rgb(255, 255, 0)'}}>Why We Matter?</h1>
            <Col sm="6" md="6" xs="6" className="float-right pb-4 pr-5">
              <picture>
                <source type="image/webp" srcSet={REDARROW_WEBP ? REDARROW_WEBP : REDARROW} />
                <LazyLoadImage src={REDARROW} alt='red_arrow' style={{width: '100%'}}/>
              </picture>
            </Col>
            <Col sm="12" md="12" xs="12" className="flora float-left mb-5 px-0">
              <Col sm="12" md="12" xs="12" className="float-left">
                <h1>Adaptive Thinking for Achieving Agility</h1>
                <h5 className="flora mb-4">Agility Thinking is the ability to bring the sustainable change. We all live in a dynamic world where change is constant. Be it Organizational Agility, Business Agility, Team Agility or Personal Agility, it is evident that we all need to constantly adapt. We, at Agility Thinking Community, strive to provide a platform for practitioners to come together and learn from each other about the art of Agility Thinking. This platform is run by the community of practitioners for the Agility Thinkers to learn from one another. We are a community with 40K+ Agility Thinkers hosting various events across various countries. It includes but not limited to Webinars every week, meetups every month in various cities and two conferences a year.</h5>
              </Col>
              <Row className="m-auto" style={{width: '75%'}}>
                {this.displayCommunityVideo()}
              </Row>
            </Col>
            <Col sm="12" md="12" xs="12" className="float-left text-center">
              <Button className="text-white" style={{backgroundColor: 'transparent',  fontWeight: 300, borderRadius: '30px', padding: '5px 20px'}} onClick={() => {this.openUrl(`/groups/${this.state.group_link}`)}}>Join Our Community
                <picture className="ml-3">
                  <source type="image/webp" srcSet={SMALLWHITE_WEBP ? SMALLWHITE_WEBP : SMALLWHITE} />
                  <LazyLoadImage src={SMALLWHITE} alt='join-community-arrow' width="24px"/>
                </picture>
              </Button>
            </Col>
          </Col>
          <Col sm="12" md="12" xs="12" className="float-left px-0" id="agility_meetup" style={{background: 'rgb(231, 243, 249)'}}>
            <h2 className="flora text-center py-3">Our Meetups</h2>
            <Col xs="7" sm="7" md="7" className="flora center mb-3 px-0">
              <nav id="nav-meetup" className="nav-fill" style={{border: '1px solid rgb(0, 0, 0)'}}>
                <div className="nav nav-tabs justify-content-center" id="nav-tab" role="tablist">
                  <a className="nav-item nav-link overlay-div pointer" id="nav-upcoming-meetup" data-toggle="tab" role="tab" aria-controls="upcoming-meetup" aria-selected="true" onClick={(e) => {this.meetupToggle(e)}} style={{border: 'none', borderRadius: '0', backgroundColor: this.state.upcoming_bgcolor, color: this.state.upcoming_textcolor}}><h5 id="upcoming-meetup-tab" className="mb-0">Upcoming</h5></a>
                  <a className="nav-item nav-link pointer" id="nav-past-meetup" data-toggle="tab" role="tab" aria-controls="past-meetup" aria-selected="false" onClick={(e) => {this.meetupToggle(e)}} style={{border: 'none', borderRadius: '0', backgroundColor: this.state.past_bgcolor , color: this.state.past_textcolor}}><h5 id="past-meetup-tab" className="mb-0">Past</h5></a>
                </div>
              </nav>
            </Col>
            <Col sm="12" md="12" xs="12" className="float-left text-center px-0">
              <Dropdown isOpen={this.state.meetupDropdownOpen} toggle={this.toggle}>
                <DropdownToggle className="test-bg" caret style={{border: '1px solid rgb(0, 0, 0)', borderRadius: '0', color: 'rgb(0, 0, 0)'}}>{this.state.city_name}</DropdownToggle>
                <DropdownMenu style={{borderRadius: '0'}}>
                  <DropdownItem value="Filter By City" onClick={(e) => {this.handleChangeCity(e)}}>Filter By City</DropdownItem>
                  {this.displayCities()}
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col sm="12" md="12" xs="12" className="float-left px-0">
              <div className="tab-content col-12 float-left px-0" id="nav-tabContent" style={{background: 'rgb(231, 243, 249)'}}>
                <div className={`col-12 float-left tab-pane fade ${this.state.upcoming_textcolor === 'rgb(255, 255, 255)' ? 'show active' : ''}`} id="nav-upcoming-meetup" role="tabpanel" aria-labelledby="upcoming-meetup">
                  <Col xs="12" xs="12" md="12" className="float-left align-item-center pr-0 pl-0 trainer-video-test-margin">
                    <i className="fa fa-angle-left font-3 pointer upmeetup-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_upcoming_meetup')}}></i>
                    <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_upcoming_meetup" onScroll={(e) => {this.handleMeetupScroll(e, 'upmeetup-angle-left', 'upmeetup-angle-right')}}>
                      <Suspense  fallback={'Loading...'}>
                        {this.displayMeetups('upcoming')}
                      </Suspense>
                    </Col>
                    <i className="fa fa-angle-right font-3 pointer upmeetup-angle-right" onClick={() => {this.scrollMeetupRight('show_upcoming_meetup')}} style={{display: this.state.right_meetup_arrow}}></i>
                  </Col>
                </div>
                <div className={`col-12 tab-pane fade ${this.state.upcoming_textcolor === 'rgb(255, 255, 255)' ? '' : 'show active'}`} id="nav-past-meetup" role="tabpanel" aria-labelledby="past-meetup">
                  <Col xs="12" xs="12" md="12" className="float-left align-item-center px-0 trainer-video-test-margin">
                    <i className="fa fa-angle-left font-3 pointer pastmeetup-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_past_meetup')}}></i>
                    <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_past_meetup" onScroll={(e) => {this.handleMeetupScroll(e, 'pastmeetup-angle-left', 'pastmeetup-angle-right')}}>
                      <Suspense  fallback={'Loading...'}>
                        {this.displayMeetups('past')}
                      </Suspense>
                    </Col>
                    <i className="fa fa-angle-right font-3 pointer pastmeetup-angle-right" onClick={() => {this.scrollMeetupRight('show_past_meetup')}} style={{display: this.state.right_past_arrow}}></i>
                  </Col>
                </div>
              </div>
            </Col>
          </Col>
          <Col sm="12" md="12" xs="12" className="float-left px-0" id="agility_webinar" style={{background: 'rgb(231, 243, 249)'}}>
            <h2 className="flora text-center py-3">Our Webinars</h2>
            <Col xs="7" sm="7" md="7" className="flora center mb-3 px-0">
              <nav id="nav-webinar" className="nav-fill" style={{border: '1px solid rgb(0, 0, 0)'}}>
                <div className="nav nav-tabs justify-content-center" id="nav-tab" role="tablist">
                  <a className="nav-item nav-link overlay-div pointer" id="nav-upcoming-webinar" data-toggle="tab" role="tab" aria-controls="upcoming-webinar" aria-selected="true" onClick={(e) => {this.webinarToggle(e)}} style={{border: 'none', borderRadius: '0', backgroundColor: this.state.upcoming_webinar_bgcolor, color: this.state.upcoming_webinar_textcolor}}><h5 id="upcoming-webinar-tab" className="mb-0">Upcoming</h5></a>
                  <a className="nav-item nav-link pointer" id="nav-past-webinar" data-toggle="tab" role="tab" aria-controls="past-webinar" aria-selected="false" onClick={(e) => {this.webinarToggle(e)}} style={{border: 'none', borderRadius: '0', backgroundColor: this.state.past_webinar_bgcolor , color: this.state.past_webinar_textcolor}}><h5 id="past-webinar-tab" className="mb-0">Past</h5></a>
                </div>
              </nav>
            </Col>
            <Col sm="12" md="12" xs="12" className="float-left px-0">
              <div className="tab-content col-12 float-left px-0" id="nav-tabContent" style={{background: 'rgb(231, 243, 249)'}}>
                <div className={`col-12 float-left tab-pane fade ${this.state.upcoming_webinar_textcolor === 'rgb(255, 255, 255)' ? 'show active' : ''}`} id="nav-upcoming-webinar" role="tabpanel" aria-labelledby="upcoming-webinar">
                  <Col xs="12" xs="12" md="12" className="float-left align-item-center pr-0 pl-0 trainer-video-test-margin">
                    <i className="fa fa-angle-left font-3 pointer upwebinar-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_upcoming_webinar')}}></i>
                    <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_upcoming_webinar" onScroll={(e) => {this.handleMeetupScroll(e, 'upwebinar-angle-left', 'upwebinar-angle-right')}}>
                      <Suspense  fallback={'Loading...'}>
                        {this.displayWebinars('upcoming')}
                      </Suspense>
                    </Col>
                    <i className="fa fa-angle-right font-3 pointer upwebinar-angle-right" onClick={() => {this.scrollMeetupRight('show_upcoming_webinar')}} style={{display: this.state.right_webinar_arrow}}></i>
                  </Col>
                </div>
                <div className={`col-12 tab-pane fade ${this.state.upcoming_webinar_textcolor === 'rgb(255, 255, 255)' ? '' : 'show active'}`} id="nav-past-webinar" role="tabpanel" aria-labelledby="past-webinar">
                  <Col xs="12" xs="12" md="12" className="float-left align-item-center px-0 trainer-video-test-margin">
                    <i className="fa fa-angle-left font-3 pointer pastwebinar-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_past_webinar')}}></i>
                    <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_past_webinar" onScroll={(e) => {this.handleMeetupScroll(e, 'pastwebinar-angle-left', 'pastwebinar-angle-right')}}>
                      <Suspense  fallback={'Loading...'}>
                        {this.displayWebinars('past')}
                      </Suspense>
                    </Col>
                    <i className="fa fa-angle-right font-3 pointer pastwebinar-angle-right" onClick={() => {this.scrollMeetupRight('show_past_webinar')}} style={{display: this.state.right_past_webinar_arrow}}></i>
                  </Col>
                  <Col sm="12" md="12" xs="12" className="float-left text-center mb-2">
                    <h6 style={{fontWeight: 400}}>The recordings of past webinars are available on Leanpitch App.</h6>
                    <Col sm="6" md="6" xs="12" className="center px-0 align-item-center mt-3">
                      <Col sm="6" md="6" xs="6" className="float-left text-center">
                        <picture className="mb-2" onClick={() => {this.openUrl('https://bit.ly/35P5vHJ')}}>
                          <source type="image/webp" srcSet={GPLAY_WEBP ? GPLAY_WEBP : GPLAY} />
                          <LazyLoadImage src={GPLAY} alt='google_play' style={{maxWidth: 'calc(80%)'}}/>
                        </picture>
                        <picture className="mb-2">
                          <source type="image/webp" srcSet={GPLAYSTORE_WEBP ? GPLAYSTORE_WEBP : GPLAYSTORE} />
                          <LazyLoadImage src={GPLAYSTORE} alt='google_play_store' style={{maxWidth: 'calc(80%)'}}/>
                        </picture>
                      </Col>
                      <Col sm="6" md="6" xs="6" className="float-left text-center">
                        <picture className="mb-2" onClick={() => {this.openUrl('https://apple.co/35P5qnp')}}>
                          <source type="image/webp" srcSet={APPLE_WEBP ? APPLE_WEBP : APPLE} />
                          <LazyLoadImage src={APPLE} alt='app_store' style={{maxWidth: 'calc(80%)'}}/>
                        </picture>
                        <picture className="mb-2">
                          <source type="image/webp" srcSet={APPLESTORE_WEBP ? APPLESTORE_WEBP : APPLESTORE} />
                          <LazyLoadImage src={APPLESTORE} alt='apple_store' style={{maxWidth: 'calc(80%)'}}/>
                        </picture>
                      </Col>
                    </Col>
                  </Col>
                </div>
              </div>
            </Col>
          </Col>
          <Col sm="12" md="12" xs="12" className="float-left px-0" id="agility_video" style={{background: 'rgb(231, 243, 249)'}}>
            <h2 className="flora text-center pt-3">Videos</h2>
            <Col sm="12" md="12" xs="12" className="float-left align-item-center px-0">
              <i className="fa fa-angle-left font-3 pointer videos-angle-left why-text-image" style={{left: '0'}} onClick={() => {this.scrollMeetupLeft('show_videos')}}></i>
              <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0 trainer-video-test-margin" id="show_videos" onScroll={(e) => {this.handleMeetupScroll(e, 'videos-angle-left', 'videos-angle-right')}}>
                <Suspense  fallback={'Loading...'}>
                  {this.displayVideos('video')}
                </Suspense>
              </Col>
              <i className="fa fa-angle-right font-3 pointer videos-angle-right" style={{right: '0'}} onClick={() => {this.scrollMeetupRight('show_videos')}} style={{display: this.state.right_vid_arrow}}></i>
            </Col>
          </Col>
          <Col sm="12" md="12" xs="12" className="float-left px-0" id="agility_pmvideo" style={{background: 'rgb(231, 243, 249)'}}>
            <h2 className="flora text-center pt-3">SM Tales Series</h2>
            <Col sm="12" md="12" xs="12" className="float-left align-item-center trainer-video-test-margin px-0">
              <i className="fa fa-angle-left font-3 pointer pmspeak-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_pmspeak')}}></i>
              <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_pmspeak" onScroll={(e) => {this.handleMeetupScroll(e, 'pmspeak-angle-left', 'pmspeak-angle-right')}}>
                <Suspense  fallback={'Loading...'}>
                  {this.displaySmTalesSeries()}
                </Suspense>
              </Col>
              <i className="fa fa-angle-right font-3 pointer pmspeak-angle-right" onClick={() => {this.scrollMeetupRight('show_pmspeak')}} style={{display: this.state.right_pmspeak_arrow}}></i>
            </Col>
          </Col>
          <Col sm="12" md="12" xs="12" className="float-left px-0" id="agility_blog" style={{background: 'rgb(231, 243, 249)'}}>
            <h2 className="flora text-center pt-3">Blogs</h2>
            <Col sm="12" md="12" xs="12" className="float-left align-item-center px-0 trainer-video-test-margin">
              <i className="fa fa-angle-left font-3 pointer blog-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_blog')}}></i>
              <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_blog" onScroll={(e) => {this.handleMeetupScroll(e, 'blog-angle-left', 'blog-angle-right')}}>
                <Suspense  fallback={'Loading...'}>
                  {this.displayBlogs()}
                </Suspense>
              </Col>
              <i className="fa fa-angle-right font-3 pointer blog-angle-right" onClick={() => {this.scrollMeetupRight('show_blog')}} style={{display: this.state.right_blogs_arrow}}></i>
            </Col>
          </Col>
          <Col sm="12" md="12" xs="12" className="float-left px-0 pt-2" id="agility_podcasts" style={{background: 'rgb(231, 243, 249)'}}>
            <h2 className="flora text-center mb-0 py-3">Podcasts</h2>
            <Col sm="12" md="12" xs="12" className="float-left align-item-center trainer-video-test-margin px-0">
              <i className="fa fa-angle-left font-3 pointer podcast-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_podcast')}}></i>
              <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_podcast" onScroll={(e) => {this.handleMeetupScroll(e, 'podcast-angle-left', 'podcast-angle-right')}}>
                <Suspense  fallback={'Loading...'}>
                  {this.displaySoundcloud()}
                </Suspense>
              </Col>
              <i className="fa fa-angle-right font-3 pointer podcast-angle-right" onClick={() => {this.scrollMeetupRight('show_podcast')}} style={{display: 'none'}} id="right_podcasts_arrow"></i>
            </Col>
          </Col>
          {this.showSpeakerContactModal()}
          {this.showVolunteerContactModal()}
        </Row>
      );
    }else{
      return (
        <Row className="animated fadeIn m-t-5">
          <Col sm="12" md="12" lg="12" className="float-left text-white px-0" style={{backgroundImage: `url(${PRODUCTDESKIMAGE})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', minHeight: 'calc(100vh - 5rem)'}}>
            <div className="overlay" style={{borderRadius: '0', background: 'rgba(0, 0, 0, 0.20)'}}></div>
            <Col sm="12" md="12" lg="12" className="float-left px-0 mt-4" id="main_all_event_div" onMouseLeave={(e) => {this.displayPtConfDiv(e)}}>
              <Col sm="4" md="4" lg="3" className="float-left agility_event_parent pr-0 overlay-div">
                <a className="text-white agility_meetup" href="#agility_meetup"><h1 className="mb-2 agility_event" style={{fontSize: '2.5vw'}} onMouseEnter={(e) => {this.displayParentSibling(e)}} id="meetup">Meetups</h1></a>
                <a className="text-white agility_webinar" href="#agility_webinar"><h1 className="mb-2 agility_event" style={{fontSize: '2.5vw'}} onMouseEnter={(e) => {this.displayParentSibling(e)}} id="webinar">Webinars</h1></a>
                <a className="text-white agility_video" href="#agility_video"><h1 className="mb-2 agility_event" style={{fontSize: '2.5vw'}} onMouseEnter={(e) => {this.displayParentSibling(e)}} id="video">Videos</h1></a>
                <a className="text-white agility_pmvideo" href="#agility_pmvideo"><h1 className="mb-2 agility_event" style={{fontSize: '2.5vw'}} onMouseEnter={(e) => {this.displayParentSibling(e)}} id="pm">SM Tales Series</h1></a>
                <a className="text-white agility_blog" href="#agility_blog"><h1 className="mb-2 agility_event" style={{fontSize: '2.5vw'}} onMouseEnter={(e) => {this.displayParentSibling(e)}} id="blog">Blogs</h1></a>
                <a className="text-white agility_podcasts" href="#agility_podcasts"><h1 className="mb-2 agility_event" style={{fontSize: '2.5vw'}} onMouseEnter={(e) => {this.displayParentSibling(e)}} id="podcasts">Podcasts</h1></a>
                <h1 className="pointer" style={{fontSize: '2.5vw'}} id="be_a_speaker" onClick={(e) => {this.toggleSpeakerModal(e)}}  onMouseEnter={(e) => {this.displayPtConfDiv(e)}}>Be A Speaker</h1>
                <h1 className="pointer" style={{fontSize: '2.5vw'}} id="be_a_volunteer" onClick={(e) => {this.toggleSpeakerModal(e)}}  onMouseEnter={(e) => {this.displayPtConfDiv(e)}}>Be A Volunteer</h1>
                <a className="text-white" href="about-us" target="_blank"><h1 style={{fontSize: '2.5vw'}} id="about_us"  onMouseEnter={(e) => {this.displayPtConfDiv(e)}}>About Us</h1></a>
              </Col>
              <Col sm="8" md="8" lg="9" id="agility_event_data" className="float-left agility_event_data overlay-div text-black" style={{minHeight: '80vh', maxHeight: '80vh', border: '5px solid rgb(255, 255, 0)', backgroundColor: 'rgba(0, 0, 0, 0.35)', overflowY: 'auto', display: 'none'}}>
                {this.displayHoverData()}
              </Col>
            </Col>
          </Col>
          <Col sm="12" md="12" lg="12" className="float-left text-white px-0 pb-5" style={{backgroundColor: `rgb(1, 19, 29)`}}>
            <h1 className="flora text-center pt-5 mb-0" style={{color: 'rgb(255, 255, 0)', fontSize: '5rem'}}>Why We Matter?</h1>
            <Col sm="6" md="6" lg="6" className="float-right pb-5">
              <picture>
                <source type="image/webp" srcSet={REDARROW_WEBP ? REDARROW_WEBP : REDARROW} />
                <LazyLoadImage src={REDARROW} alt='red_arrow'/>
              </picture>
            </Col>
            <Col sm="12" md="11" lg="11" className="align-item-center flora center mb-5 px-0">
              <Col sm="7" md="7" lg="7">
                <h1 style={{fontSize: '3.25rem'}}>Adaptive Thinking for Achieving Agility</h1>
                <h3>Agility Thinking is the ability to bring the sustainable change. We all live in a dynamic world where change is constant. Be it Organizational Agility, Business Agility, Team Agility or Personal Agility, it is evident that we all need to constantly adapt. We, at Agility Thinking Community, strive to provide a platform for practitioners to come together and learn from each other about the art of Agility Thinking. This platform is run by the community of practitioners for the Agility Thinkers to learn from one another. We are a community with 40K+ Agility Thinkers hosting various events across various countries. It includes but not limited to Webinars every week, meetups every month in various cities and two conferences a year.</h3>
              </Col>
              <Col sm="5" md="5" lg="5" className="float-left" style={{position: 'relative'}}>
                {this.displayCommunityVideo()}
              </Col>
            </Col>
            <Col sm="12" md="12" lg="12" className="float-left text-center">
              <Button className="text-white" style={{backgroundColor: 'transparent', fontSize: '2rem', fontWeight: 300, borderRadius: '30px', padding: '5px 20px'}} onClick={() => {this.openUrl(`/groups/${this.state.group_link}`)}}>Join Our Community
                <picture className="ml-3">
                  <source type="image/webp" srcSet={SMALLWHITE_WEBP ? SMALLWHITE_WEBP : SMALLWHITE} />
                  <LazyLoadImage src={SMALLWHITE} alt='join-community-arrow'/>
                </picture>
              </Button>
            </Col>
          </Col>
          <Col sm="12" md="12" lg="12" className="float-left px-0 pb-5" id="agility_meetup" style={{background: 'rgb(231, 243, 249)'}}>
            <h1 className="flora text-center pb-4 pt-5" style={{fontSize: '5rem'}}>Our Meetups</h1>
            <Col sm="6" md="6" lg="5" className="flora center mb-5 px-0 align-item-center" style={{justifyContent: 'center'}}>
              <nav id="nav-meetup" className="nav-fill mr-4" style={{border: '1px solid rgb(0, 0, 0)'}}>
                <div className="nav nav-tabs justify-content-center" id="nav-tab" role="tablist">
                  <a className="nav-item nav-link overlay-div pointer" id="nav-upcoming-meetup" data-toggle="tab" role="tab" aria-controls="upcoming-meetup" aria-selected="true" onClick={(e) => {this.meetupToggle(e)}} style={{border: 'none', borderRadius: '0', backgroundColor: this.state.upcoming_bgcolor, color: this.state.upcoming_textcolor}}><h2 id="upcoming-meetup-tab" className="mb-0">Upcoming</h2></a>
                  <a className="nav-item nav-link pointer" id="nav-past-meetup" data-toggle="tab" role="tab" aria-controls="past-meetup" aria-selected="false" onClick={(e) => {this.meetupToggle(e)}} style={{border: 'none', borderRadius: '0', backgroundColor: this.state.past_bgcolor , color: this.state.past_textcolor}}><h2 id="past-meetup-tab" className="mb-0">Past</h2></a>
                </div>
              </nav>
              <Dropdown isOpen={this.state.meetupDropdownOpen} toggle={this.toggle}>
                <DropdownToggle className="test-bg" style={{border: '1px solid rgb(0, 0, 0)', borderRadius: '0', color: 'rgb(0, 0, 0)'}}><i className="fa fa-filter"></i>&nbsp;&nbsp;&nbsp;{this.state.city_name}</DropdownToggle>
                <DropdownMenu style={{borderRadius: '0'}}>
                  <DropdownItem value="Filter By City" onClick={(e) => {this.handleChangeCity(e)}}>Filter By City</DropdownItem>
                  {this.displayCities()}
                </DropdownMenu>
              </Dropdown>
            </Col>
            <Col sm="12" md="12" lg="12" className="float-left">
              <div className="tab-content col-12 float-left" id="nav-tabContent" style={{background: 'rgb(231, 243, 249)'}}>
                <div className={`col-12 float-left tab-pane fade ${this.state.upcoming_textcolor === 'rgb(255, 255, 255)' ? 'show active' : ''}`} id="nav-upcoming-meetup" role="tabpanel" aria-labelledby="upcoming-meetup">
                  <Col xs="12" xs="12" md="12" className="float-left align-item-center px-0 trainer-video-test-margin">
                    <i className="fa fa-angle-left font-3 pointer upmeetup-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_upcoming_meetup')}}></i>
                    <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_upcoming_meetup" onScroll={(e) => {this.handleMeetupScroll(e, 'upmeetup-angle-left', 'upmeetup-angle-right')}}>
                      <Suspense  fallback={'Loading...'}>
                        {this.displayMeetups('upcoming')}
                      </Suspense>
                    </Col>
                    <i className="fa fa-angle-right font-3 pointer upmeetup-angle-right" onClick={() => {this.scrollMeetupRight('show_upcoming_meetup')}} style={{display: this.state.right_meetup_arrow}}></i>
                  </Col>
                </div>
                <div className={`col-12 tab-pane fade ${this.state.upcoming_textcolor === 'rgb(255, 255, 255)' ? '' : 'show active'}`} id="nav-past-meetup" role="tabpanel" aria-labelledby="past-meetup">
                  <Col xs="12" xs="12" md="12" className="float-left align-item-center px-0 trainer-video-test-margin">
                    <i className="fa fa-angle-left font-3 pointer pastmeetup-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_past_meetup')}}></i>
                    <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_past_meetup" onScroll={(e) => {this.handleMeetupScroll(e, 'pastmeetup-angle-left', 'pastmeetup-angle-right')}}>
                      <Suspense  fallback={'Loading...'}>
                        {this.displayMeetups('past')}
                      </Suspense>
                    </Col>
                    <i className="fa fa-angle-right font-3 pointer pastmeetup-angle-right" onClick={() => {this.scrollMeetupRight('show_past_meetup')}} style={{display: this.state.right_past_arrow}}></i>
                  </Col>
                </div>
              </div>
            </Col>
          </Col>
          <Col sm="12" md="12" lg="12" className="float-left px-0 pb-5" id="agility_webinar" style={{background: 'rgb(231, 243, 249)'}}>
            <h1 className="flora text-center pb-4" style={{fontSize: '5rem'}}>Our Webinars</h1>
            <Col sm="4" md="3" lg="3" className="flora center mb-5 px-0">
              <nav id="nav-webinar" className="nav-fill" style={{border: '1px solid rgb(0, 0, 0)'}}>
                <div className="nav nav-tabs justify-content-center" id="nav-tab" role="tablist">
                  <a className="nav-item nav-link overlay-div pointer" id="nav-upcoming-webinar" data-toggle="tab" role="tab" aria-controls="upcoming-webinar" aria-selected="true" onClick={(e) => {this.webinarToggle(e)}} style={{border: 'none', borderRadius: '0', backgroundColor: this.state.upcoming_webinar_bgcolor, color: this.state.upcoming_webinar_textcolor}}><h2 id="upcoming-webinar-tab" className="mb-0">Upcoming</h2></a>
                  <a className="nav-item nav-link pointer" id="nav-past-webinar" data-toggle="tab" role="tab" aria-controls="past-webinar" aria-selected="false" onClick={(e) => {this.webinarToggle(e)}} style={{border: 'none', borderRadius: '0', backgroundColor: this.state.past_webinar_bgcolor , color: this.state.past_webinar_textcolor}}><h2 id="past-webinar-tab" className="mb-0">Past</h2></a>
                </div>
              </nav>
            </Col>
            <Col sm="12" md="12" lg="12" className="float-left">
              <div className="tab-content col-12 float-left" id="nav-tabContent" style={{background: 'rgb(231, 243, 249)'}}>
                <div className={`col-12 float-left tab-pane fade ${this.state.upcoming_webinar_textcolor === 'rgb(255, 255, 255)' ? 'show active' : ''}`} id="nav-upcoming-meetup" role="tabpanel" aria-labelledby="upcoming-meetup">
                  <Col xs="12" xs="12" md="12" className="float-left align-item-center pr-0 pl-0 trainer-video-test-margin">
                    <i className="fa fa-angle-left font-3 pointer upwebinar-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_upcoming_webinar')}}></i>
                    <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_upcoming_webinar" onScroll={(e) => {this.handleMeetupScroll(e, 'upwebinar-angle-left', 'upwebinar-angle-right')}}>
                      <Suspense  fallback={'Loading...'}>
                        {this.displayWebinars('upcoming')}
                      </Suspense>
                    </Col>
                    <i className="fa fa-angle-right font-3 pointer upwebinar-angle-right" onClick={() => {this.scrollMeetupRight('show_upcoming_webinar')}} style={{display: this.state.right_webinar_arrow}}></i>
                  </Col>
                </div>
                <div className={`col-12 tab-pane fade ${this.state.upcoming_webinar_textcolor === 'rgb(255, 255, 255)' ? '' : 'show active'}`} id="nav-past-meetup" role="tabpanel" aria-labelledby="past-meetup">
                  <Col xs="12" xs="12" md="12" className="float-left align-item-center px-0 trainer-video-test-margin">
                    <i className="fa fa-angle-left font-3 pointer pastwebinar-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_past_webinar')}}></i>
                    <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_past_webinar" onScroll={(e) => {this.handleMeetupScroll(e, 'pastwebinar-angle-left', 'pastwebinar-angle-right')}}>
                      <Suspense  fallback={'Loading...'}>
                        {this.displayWebinars('past')}
                      </Suspense>
                    </Col>
                    <i className="fa fa-angle-right font-3 pointer pastwebinar-angle-right" onClick={() => {this.scrollMeetupRight('show_past_webinar')}} style={{display: this.state.right_past_webinar_arrow}}></i>
                  </Col>
                  <Col sm="12" md="12" lg="12" className="float-left text-center">
                    <h5>The recordings of past webinars are available on Leanpitch App.</h5>
                    <Col sm="6" md="5" lg="4" className="center px-0 align-item-center mt-3">
                      <Col sm="6" md="6" lg="6" className="float-left text-center">
                        <picture className="mb-2 pointer" onClick={() => {this.openUrl('https://bit.ly/35P5vHJ')}}>
                          <source type="image/webp" srcSet={GPLAY_WEBP ? GPLAY_WEBP : GPLAY} />
                          <LazyLoadImage src={GPLAY} alt='google_play' style={{maxWidth: 'calc(80%)'}}/>
                        </picture>
                        <picture className="mb-2">
                          <source type="image/webp" srcSet={GPLAYSTORE_WEBP ? GPLAYSTORE_WEBP : GPLAYSTORE} />
                          <LazyLoadImage src={GPLAYSTORE} alt='google_play_store' style={{maxWidth: 'calc(80%)'}}/>
                        </picture>
                      </Col>
                      <Col sm="6" md="6" lg="6" className="float-left text-center">
                        <picture className="mb-2 pointer" onClick={() => {this.openUrl('https://apple.co/35P5qnp')}}>
                          <source type="image/webp" srcSet={APPLE_WEBP ? APPLE_WEBP : APPLE} />
                          <LazyLoadImage src={APPLE} alt='app_store' style={{maxWidth: 'calc(80%)'}}/>
                        </picture>
                        <picture className="mb-2">
                          <source type="image/webp" srcSet={APPLESTORE_WEBP ? APPLESTORE_WEBP : APPLESTORE} />
                          <LazyLoadImage src={APPLESTORE} alt='apple_store' style={{maxWidth: 'calc(80%)'}}/>
                        </picture>
                      </Col>
                    </Col>
                  </Col>
                </div>
              </div>
            </Col>
          </Col>
          <Col sm="12" md="12" lg="12" className="float-left px-0 pb-5" id="agility_video" style={{background: 'rgb(231, 243, 249)'}}>
            <h1 className="flora text-center" style={{fontSize: '5rem'}}>Videos</h1>
            <Col sm="12" md="12" xs="12" className="float-left align-item-center">
              <i className="fa fa-angle-left font-3 pointer videos-angle-left why-text-image video_angle_position" style={{left: '0'}} onClick={() => {this.scrollMeetupLeft('show_videos')}}></i>
              <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_videos" onScroll={(e) => {this.handleMeetupScroll(e, 'videos-angle-left', 'videos-angle-right')}}>
                <Suspense  fallback={'Loading...'}>
                  {this.displayVideos('video')}
                </Suspense>
              </Col>
              <i className="fa fa-angle-right font-3 pointer videos-angle-right video_angle_position" style={{right: '0'}} onClick={() => {this.scrollMeetupRight('show_videos')}} style={{display: this.state.right_vid_arrow}}></i>
            </Col>
          </Col>
          <Col sm="12" md="12" lg="12" className="float-left px-0 pb-5" id="agility_pmvideo" style={{background: 'rgb(231, 243, 249)'}}>
            <h1 className="flora text-center pb-3" style={{fontSize: '5rem'}}>SM Tales Series</h1>
            <Col sm="12" md="12" xs="12" className="float-left align-item-center trainer-video-test-margin">
              <i className="fa fa-angle-left font-3 pointer pmspeak-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_pmspeak')}}></i>
              <Col sm="11" md="11" xs="11" className="center inline-flex-mobile-modal px-0" id="show_pmspeak" onScroll={(e) => {this.handleMeetupScroll(e, 'pmspeak-angle-left', 'pmspeak-angle-right')}}>
                <Suspense  fallback={'Loading...'}>
                  {this.displaySmTalesSeries()}
                </Suspense>
              </Col>
              <i className="fa fa-angle-right font-3 pointer pmspeak-angle-right" onClick={() => {this.scrollMeetupRight('show_pmspeak')}} style={{display: this.state.right_pmspeak_arrow}}></i>
            </Col>
          </Col>
          <Col sm="12" md="12" lg="12" className="float-left px-0 pb-5" id="agility_blog" style={{background: 'rgb(231, 243, 249)'}}>
            <h1 className="flora text-center pb-4" style={{fontSize: '5rem'}}>Blogs</h1>
            <Col sm="12" md="12" lg="12" className="float-left align-item-center">
              <i className="fa fa-angle-left font-3 pointer blog-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_blog')}}></i>
              <Col sm="11" md="11" lg="11" className="center inline-flex-mobile-modal px-0" id="show_blog" onScroll={(e) => {this.handleMeetupScroll(e, 'blog-angle-left', 'blog-angle-right')}}>
                <Suspense  fallback={'Loading...'}>
                  {this.displayBlogs()}
                </Suspense>
              </Col>
              <i className="fa fa-angle-right font-3 pointer blog-angle-right" onClick={() => {this.scrollMeetupRight('show_blog')}} style={{display: this.state.right_blogs_arrow}}></i>
            </Col>
          </Col>
          <Col sm="12" md="12" lg="12" className="float-left px-0 pb-5" id="agility_podcasts" style={{background: 'rgb(231, 243, 249)'}}>
            <h1 className="flora text-center" style={{fontSize: '5rem'}}>Podcasts</h1>
            <Col sm="12" md="12" lg="12" className="float-left align-item-center">
              <i className="fa fa-angle-left font-3 pointer podcast-angle-left why-text-image" onClick={() => {this.scrollMeetupLeft('show_podcast')}}></i>
              <Col sm="11" md="11" lg="11" className="center inline-flex-mobile-modal px-0" id="show_podcast" onScroll={(e) => {this.handleMeetupScroll(e, 'podcast-angle-left', 'podcast-angle-right')}}>
                <Suspense  fallback={'Loading...'}>
                  {this.displaySoundcloud()}
                </Suspense>
              </Col>
              <i className="fa fa-angle-right font-3 pointer desk_video_right podcast-angle-right" onClick={() => {this.scrollMeetupRight('show_podcast')}} style={{display: this.state.podcast_arrow}} id="right_podcasts_arrow"></i>
            </Col>
          </Col>
          {this.showSpeakerContactModal()}
          {this.showVolunteerContactModal()}
        </Row>
      );
    }
  }
}

export default AgilityThinking;
